import {
  Box,
  Flex,
  Image,
  Step,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Text,
  Textarea,
  HStack,
  Radio,
  RadioGroup
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { AddDoctorNotes, DeleteDoctorNotes, DischargePatient, EditDoctorNotes, FetchChiefComplaint, FetchDoctorNotes, FetchDoctorNoteType } from "../../middleware/services/messages";
import moment from "moment";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import DynamicModal from "../../components/dynamic-modal";
import { useScreenType, uploadImageCommonFunction } from "../../auth";
import { GPUChatAudioManager } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManager";
import { useGPUTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useGPUTranscriber";
import { useForm } from "react-hook-form";
import { CorrectChiefComplaintUsingAI, CorrectMedicalTermsUsingAI } from "../../middleware/services/visits/aicalls";
import DatePicker from "../../components/date-picker";
import { FetchDoctorsByUser, FetchUsersByClinic } from "../../middleware/services/home";
import { format } from "date-fns";
import { useHybridTranscriber } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/useHybridTranscriber";
import { GPUChatAudioManagerSpeechMode } from "../../components/patient-health/doctor-notes/cheif-complaint-audio/gpuChatVoiceManagerSpeechMode";
import DropdownInputDoctorList from "../../components/dropdown-input-doc-list";
import DropdownWithMultiLingual from "../../components/dropdown-multilingual";
import DotElasticAnimation from "../../components/dot-listening";
import { AudioDisplay } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display";
import { AudioDisplayForClutter } from "../../components/patient-health/doctor-notes/notes-transcription/utils/audio-display-multi-lingual";


const DoctorNotesIndex = ({ id, backFunction, doctorId, appointmentid }) => {

  const location = useLocation();
  const [patientid, setPatientid] = useState("");
  const [audioPath, setAudioPath] = useState("");
  const [doctorNotesData, setDoctorNotesData] = useState(null);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const navigate = useNavigate()
  const { showSuccessToast, showErrorToast } = Toaster();
  const screenType = useScreenType()

  const deleteGeneralDoctorNotesModal = useRef();
  const editGeneralDoctorNotesModal = useRef();
  const addGeneralDoctorNotesModal = useRef();
  const dischargePatientModal = useRef();

  const dynamicModal = React.useRef();
  const [appointmentId, setAppointmentId] = useState(null);
  var [DoctorList, setDoctorList] = useState([]);
  var [doctorData, setDoctorData] = useState([]);
  var [noteTypeData, setNoteTypeData] = useState([]);
  var [noteTypeCompleteData, setNoteTypeCompleteData] = useState([]);
  const [noteTypeId, setNoteTypeId] = useState(null);
  // const [noteType, setNoteType] = useState(null);
  const [noteType, setNoteType] = useState("Consultation Note");
  // var [doctorData, setDoctorData] = useState([]);
  var [DefaultDoctor, setDefaultDoctor] = useState(null);
  const [date, setDate] = useState(moment().format("DD-MM-yyyy"));
  const [time, setTime] = useState(moment().format("HH:mm"));
  const [isDateChanged, setIsDateChanged] = useState(false);

  useEffect(() => {
    const currentUrl = window.location.href;
    const searchParams = new URLSearchParams(currentUrl.split('?')[1]);
    const id = searchParams.get('id');
    const getappointmentid = searchParams.get('appointmentid');
    const loginInfo = localStorage.getItem("LoginInfo");

if (loginInfo) {
  const parsedLoginInfo = JSON.parse(loginInfo);

  const imagePath = parsedLoginInfo.imagepath;
  setAudioPath(imagePath || "");

  console.log("imagePath:", imagePath);
}

    setPatientid(id);

    if (getappointmentid) {
      setAppointmentId(getappointmentid);
    }

    if (getappointmentid) {
      fetchdoctornotesdata(id, getappointmentid)
    } else {
      fetchdoctornotesdata(id, "")
    }
    // fetchdoctornotesdata(id)
  }, []);

  const fetchdoctornotesdata = async (id, apmtid = "") => {
    showLoader()
    try {
      const result = await FetchDoctorNotes({
        "patientid": id,
        ...(apmtid && { appointmentid: apmtid }),
        ...(apmtid && { type: 'ipd' })
      });

      if (result && result.output.result == 'success') {
        console.log(result.output.data)
        setDoctorNotesData(result.output.data);
      } else {
        setDoctorNotesData(null)
      }
      dismissLoader()
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("Do MMM, YYYY");
  };
  const formatDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;

    try {
      const date = new Date(dateTimeString);

      // Get day with ordinal suffix
      const day = date.getDate();
      const dayWithSuffix = day + (day % 10 === 1 && day !== 11 ? 'st' :
        day % 10 === 2 && day !== 12 ? 'nd' :
          day % 10 === 3 && day !== 13 ? 'rd' : 'th');

      // Get month abbreviation
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];

      // Get year
      const year = date.getFullYear();

      // Format time in 12-hour format with a.m./p.m.
      let hours = date.getHours();
      let minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'p.m.' : 'a.m.';

      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;

      return `${dayWithSuffix} ${month}, ${year} at ${hours}:${minutes} ${ampm}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return null;
    }
  };

  // CRUD Operation ------------------------------------------

  const getLocalISOString = (dateStr, timeStr) => {
    // Parse the date in DD-MM-yyyy format
    const [day, month, year] = dateStr.split("-").map(Number);
    // Parse the time in HH:mm format
    const [hours, minutes] = timeStr.split(":").map(Number);

    // Create a Date object in local timezone
    const dateObj = new Date(year, month - 1, day, hours, minutes, 0);

    // Format to ISO string with local timezone offset
    const timezoneOffset = dateObj.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(dateObj - timezoneOffset).toISOString().slice(0, 19).replace('Z', '');

    return localISOTime;
  };

  const [addGeneralDoctorNotes, setAddGeneralDoctorNotes] = useState('')
  const [updateGeneralDoctorNotes, setUpdateGeneralDoctorNotes] = useState('')
  const [generalEditNotesId, setGeneralEditNotesId] = useState(null)
  const [generalDeleteNotesId, setGeneralDeleteNotesId] = useState(null)

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const openAddDoctornotesModal = async () => {
    setPlaceholder("Instructions")
    setValue("textField", ""); // Clear the form value
    setAddGeneralDoctorNotes('')
    setDefaultDoctor(null);
    setDate(moment().format("DD-MM-yyyy"));
    setTime(moment().format("HH:mm"));
    setSelectedLanguage('en-US')

    // Set the note type name first
    setNoteType('Consultation Note');

    // Fetch doctors and note types first
    await fetchDoctors(true);

    // Get the note types data directly from the function, not from state
    const noteTypesData = await fetchDoctorsNoteTypes(true); // Pass true to set default

    // If fetchDoctorsNoteTypes didn't set the ID (first time), set it here
    if (noteTypesData) {
      const consultationNote = noteTypesData.find(item => item.subtype === "Consultation Note");
      console.log('consultationNOTE: ', consultationNote);

      if (consultationNote && !noteTypeId) { // Only set if not already set
        setNoteTypeId(consultationNote.id);
        console.log('Setting noteTypeId in open modal:', consultationNote.id);
      }
    }

    // Clear any previous audio state so Add modal starts fresh
    setAudioBlob(null);
    setAudioUrl("");
    setUploadedAudioName(null);
    setPendingAudioSave(false);
    try { localStorage.removeItem('audioUrl'); } catch (e) { /* ignore */ }

    setIsAddModalOpen(true);
    addGeneralDoctorNotesModal.current.openModal();
  }
  // const openAddDoctornotesModal = async () => {
  //   setNoteType('Consultation Note')
  //   setNoteTypeId(null)
  //   setPlaceholder("Instructions")
  //   setValue("textField", ""); // Clear the form value
  //   setAddGeneralDoctorNotes('')
  //   // setAddGeneralDoctorNotes('')
  //   // setValue("textField", ""); // Clear the form value
  //   setDefaultDoctor(null);
  //   setDate(moment().format("DD-MM-yyyy"));
  //   setTime(moment().format("HH:mm"));
  //   setSelectedLanguage('en-US')

  //   // Fetch doctors and note types first
  // await fetchDoctors(true);
  // await fetchDoctorsNoteTypes();

  // // Find the Consultation Note ID from the fetched data
  // const consultationNote = noteTypeCompleteData.find(item => 
  //   item.subtype === "Consultation Note"
  // );
  // console.log('consultationNOTE: ', consultationNote)

  // if (consultationNote) {
  //   alert('hit')
  //   setNoteTypeId(consultationNote.id);
  //   console.log('Setting noteTypeId:', consultationNote.id);
  // } else {
  //   alert('esle hti')
  //   // Fallback: if Consultation Note not found, use first available note type
  //   if (noteTypeCompleteData.length > 0) {
  //     alert('nested if hoit')
  //     setNoteType(noteTypeCompleteData[0].subtype);
  //     setNoteTypeId(noteTypeCompleteData[0].id);
  //     console.log('Fallback - Setting noteTypeId:', noteTypeCompleteData[0].id);
  //   }
  // }

  //   // setNoteType("Consultation Note")
  //   // // setNoteType(null)
  //   // setNoteTypeId(null)
  //   // fetchDoctors(true);
  //   // fetchDoctorsNoteTypes();
  //   setIsAddModalOpen(true);
  //   addGeneralDoctorNotesModal.current.openModal();
  // }
  const addDoctorNotes = async () => {
  // Ensure recording is stopped before saving
  forceStopRecording();
  
  let updatedById;
  if (typeof DefaultDoctor === 'string') {
    const doctor = doctorData.find(d => d.fullname === DefaultDoctor);
    if (doctor) {
      updatedById = doctor.doctorid;
    }
  } else {
    updatedById = DefaultDoctor?.doctorid;
  }

  // Get audio URL from state or localStorage
  const audioUrlToSave = uploadedAudioName || localStorage.getItem('audioUrl') || undefined;

  const inputToSave = {
    input: {
      appointmentid: appointmentid,
      doctorid: doctorId,
      patientid: patientid,
      updateddate: getLocalISOString(date, time),
      updatedby: updatedById,
      notetypeid: noteTypeId,
      audiourl: audioUrlToSave, // This is the filename from uploadImageCommonFunction
      generalnotedetail: [
        {
          generalnote: addGeneralDoctorNotes || textFieldValue
        }
      ]
    }
  }

  console.log('Saving notes with audio:', audioUrlToSave);

  try {
    const result = await AddDoctorNotes(inputToSave.input);

    if (result?.output?.message == 'Successfully Inserted') {
      if (appointmentId) {
        fetchdoctornotesdata(patientid, appointmentId)
      } else {
        fetchdoctornotesdata(patientid)
      }
      showSuccessToast("Notes Updated Successfully")
      
      // Clear states
      setAddGeneralDoctorNotes("");
      setValue("textField", "", {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false,
      });
      setPlaceholder("Instructions");
      
      // Clear audio state
      setAudioBlob(null);
      setAudioUrl("");
      setUploadedAudioName(null);
      localStorage.removeItem('audioUrl');

      addGeneralDoctorNotesModal.current.closeModal();
      setIsAddModalOpen(false);
    }
  } catch (error) {
    console.error("Error in Add Doctor Notes:", error);
    throw error;
  }
};
  // const openEditNotesModal = (complaint) => {
  //   console.log(complaint, "complaint in edit notes modal")

  //   if (appointmentid) {
  //     setDate(moment(complaint.updateddate).format("DD-MM-yyyy"));
  //     setTime(moment(complaint.updateddate).format("HH:mm"));
  //     setGeneralEditNotesId(complaint.id)
  //     setUpdateGeneralDoctorNotes(complaint.generalnote)
  //     setValue("textField", complaint.generalnote);
  //     setSelectedLanguage('en-US')
  //     setIsRecording(false)

  //     // Find the doctor from doctorData and get their specialties
  //     const doctorFromData = doctorData.find(doc => doc.doctorid == complaint.doctorid);
  //     const doctorDetails = getDoctorDetails(doctorFromData);
  //     const doctorWithDetails = doctorFromData ? {
  //       ...doctorFromData,
  //       specialties: doctorDetails.specialties,
  //       experience: doctorDetails.experience
  //     } : {
  //       fullname: complaint.doctorname,
  //       specialties: "",
  //       experience: ""
  //     };
  //     // const doctorWithSpecialties = doctorFromData ? {
  //     //   ...doctorFromData,
  //     //   specialties: getDoctorSpecialties(doctorFromData)
  //     // } : { fullname: complaint.doctorname, specialties: "" };

  //     setDefaultDoctor(doctorWithDetails);
  //     setDoctorExperience(doctorDetails.experience);

  //     // Set note type immediately from complaint data
  //     setNoteTypeId(complaint.notetypeid);
  //     setNoteType(complaint.codevalue);
  //     console.log('Initial note type set:', complaint.codevalue, 'ID:', complaint.notetypeid);

  //   } else {
  //     setGeneralEditNotesId(complaint.id)
  //     setUpdateGeneralDoctorNotes(complaint.generalnote)
  //     setValue("textField", complaint.generalnote);
  //   }

  //   setIsEditModalOpen(true)
  //   fetchDoctors();
  //   fetchDoctorsNoteTypes();
  //   editGeneralDoctorNotesModal.current.openModal();
  // }
  // Add this helper function to clear transcriber output
// const clearTranscriberState = () => {
//   if (activeTranscriber && activeTranscriber.output) {
//     // Clear the transcriber output
//     activeTranscriber.output.text = "";
//     activeTranscriber.output.chunks = [];
//   }
  
//   // Stop any ongoing recording
//   if (recorderRef.current && recorderRef.current.state === "recording") {
//     recorderRef.current.stop();
//   }
  
//   setIsRecording(false);
//   setRecording(false);
//   setChunks([]);
// };

//   const openEditNotesModal = async (complaint) => {
//   console.log(complaint, "complaint in edit notes modal");

//   // Reset all relevant states first
//   setUpdateGeneralDoctorNotes("");
//   setValue("textField", "");
//   setPlaceholder("Instructions");
//   setSelectedLanguage('en-US');
//   setInpLang("English");
//   setOutputLang("English");
//   setIsRecording(false);
  
//   // Clear audio/recording state
//   if (recorderRef.current && recorderRef.current.state === "recording") {
//     recorderRef.current.stop();
//   }

//   if (appointmentid) {
//     setDate(moment(complaint.updateddate).format("DD-MM-yyyy"));
//     setTime(moment(complaint.updateddate).format("HH:mm"));
//     setGeneralEditNotesId(complaint.id);
    
//     // Set the note content AFTER resetting
//     setUpdateGeneralDoctorNotes(complaint.generalnote || "");
//     setValue("textField", complaint.generalnote || "");
    
//     setSelectedLanguage('en-US');
//     setIsRecording(false);

//     // Find the doctor from doctorData and get their specialties
//     const doctorFromData = doctorData.find(doc => doc.doctorid == complaint.doctorid);
    
//     // Use a function to ensure doctor details are properly set
//     const setDoctorDetails = async () => {
//       if (doctorFromData) {
//         const doctorDetails = getDoctorDetails(doctorFromData);
//         const doctorWithDetails = {
//           ...doctorFromData,
//           specialties: doctorDetails.specialties || "",
//           experience: doctorDetails.experience || ""
//         };
        
//         setDefaultDoctor(doctorWithDetails);
//         setDoctorExperience(doctorDetails.experience || "");
//         console.log('Doctor details set:', doctorWithDetails);
//       } else {
//         // Fallback if doctor not found in doctorData
//         const fallbackDoctor = {
//           fullname: complaint.doctorname || "Unknown Doctor",
//           specialties: complaint.specality || complaint.specialization || "",
//           experience: ""
//         };
//         setDefaultDoctor(fallbackDoctor);
//         setDoctorExperience("");
//       }
//     };

//     await setDoctorDetails();

//     // Set note type immediately from complaint data
//     setNoteTypeId(complaint.notetypeid || "");
//     setNoteType(complaint.codevalue || "Consultation Note");
//     console.log('Note type set:', complaint.codevalue, 'ID:', complaint.notetypeid);

//   } else {
//     // Reset states for non-appointment flow
//     setGeneralEditNotesId(complaint.id);
//     setUpdateGeneralDoctorNotes(complaint.generalnote || "");
//     setValue("textField", complaint.generalnote || "");
//   }

//   // Fetch fresh data
//   await fetchDoctors();
//   await fetchDoctorsNoteTypes();
  
//   setIsEditModalOpen(true);
//   editGeneralDoctorNotesModal.current.openModal();
// };
// UPDATED openEditNotesModal function
const openEditNotesModal = async (complaint) => {
  console.log(complaint, "complaint in edit notes modal");

  // CRITICAL: Clear transcriber state FIRST
  clearTranscriberState();
  
  // Reset all relevant states
  setUpdateGeneralDoctorNotes("");
  setValue("textField", "");
  setPlaceholder("Instructions");
  setSelectedLanguage('en-US');
  setInpLang("English");
  setOutputLang("English");
  setIsRecording(false);
  setRecording(false);
  setChunks([]);
  
  // Small delay to ensure transcriber is fully reset
  await new Promise(resolve => setTimeout(resolve, 100));

  if (appointmentid) {
    setDate(moment(complaint.updateddate).format("DD-MM-yyyy"));
    setTime(moment(complaint.updateddate).format("HH:mm"));
    setGeneralEditNotesId(complaint.id);
    
    // Set the note content AFTER clearing transcriber
    const noteContent = complaint.generalnote || "";
    setUpdateGeneralDoctorNotes(noteContent);
    setValue("textField", noteContent, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    });
    
    setSelectedLanguage('en-US');
    setIsRecording(false);
    if (complaint.audiourl) {
  setAudioUrl(audioPath ? audioPath + complaint.audiourl : complaint.audiourl);
  setUploadedAudioName(complaint.audiourl);
} else {
  setAudioUrl("");
  setUploadedAudioName(null);
}


    // If this complaint has existing audio, bind it for playback
    // if (complaint.audiourl) {
    //   // Full URL is available as complaint.imagepath + complaint.audiourl
    //   setAudioUrl(complaint.imagepath ? complaint.imagepath + complaint.audiourl : complaint.audiourl);
    //   setUploadedAudioName(complaint.audiourl);
    // } else {
    //   setAudioUrl("");
    //   setUploadedAudioName(null);
    // }

    // Find the doctor from doctorData and get their specialties
    const doctorFromData = doctorData.find(doc => doc.doctorid == complaint.doctorid);
    
    const setDoctorDetails = async () => {
      if (doctorFromData) {
        const doctorDetails = getDoctorDetails(doctorFromData);
        const doctorWithDetails = {
          ...doctorFromData,
          specialties: doctorDetails.specialties || "",
          experience: doctorDetails.experience || ""
        };
        
        setDefaultDoctor(doctorWithDetails);
        setDoctorExperience(doctorDetails.experience || "");
        console.log('Doctor details set:', doctorWithDetails);
      } else {
        const fallbackDoctor = {
          fullname: complaint.doctorname || "Unknown Doctor",
          specialties: complaint.specality || complaint.specialization || "",
          experience: ""
        };
        setDefaultDoctor(fallbackDoctor);
        setDoctorExperience("");
      }
    };

    await setDoctorDetails();

    // Set note type
    setNoteTypeId(complaint.notetypeid || "");
    setNoteType(complaint.codevalue || "Consultation Note");
    console.log('Note type set:', complaint.codevalue, 'ID:', complaint.notetypeid);

  } else {
    setGeneralEditNotesId(complaint.id);
    const noteContent = complaint.generalnote || "";
    setUpdateGeneralDoctorNotes(noteContent);
    setValue("textField", noteContent, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    });
  }

  // Fetch fresh data
  await fetchDoctors();
  await fetchDoctorsNoteTypes();
  
  // Another small delay before opening modal
  await new Promise(resolve => setTimeout(resolve, 50));
  
  setIsEditModalOpen(true);
  editGeneralDoctorNotesModal.current.openModal();
};
  // const openEditNotesModal = (complaint) => {
  //   console.log(complaint, "complaint in edit notes modal")
  //   if(appointmentid){
  //     setDate(moment(complaint.updateddate).format("DD-MM-yyyy"));
  //     setTime(moment(complaint.updateddate).format("HH:mm"));
  //     setGeneralEditNotesId(complaint.id)
  //     setUpdateGeneralDoctorNotes(complaint.generalnote)
  //     setValue("textField", complaint.generalnote);

  //     // Find the doctor from doctorData and get their specialties
  //   const doctorFromData = doctorData.find(doc => doc.doctorid == complaint.doctorid);
  //   const doctorWithSpecialties = doctorFromData ? {
  //     ...doctorFromData,
  //     specialties: getDoctorSpecialties(doctorFromData)
  //   } : { fullname: complaint.doctorname, specialties: "" };

  //   setDefaultDoctor(doctorWithSpecialties);
  //     // setDefaultDoctor(complaint.doctorname);
  //     setNoteTypeId(complaint.notetypeid);
  //     setNoteType(complaint.codevalue);

  //     // Find the doctor object by name and set it
  //   //   if(complaint.doctorname) {
  //   //     setDefaultDoctor(complaint.doctorname)
  //   //   }
  //   // const selectedDoctor = doctorData.find(doc => doc.fullname === complaint.doctorname);
  //   // setDefaultDoctor(selectedDoctor || null);
  //   } else {
  //     setGeneralEditNotesId(complaint.id)
  //     setUpdateGeneralDoctorNotes(complaint.generalnote)
  //     setValue("textField", complaint.generalnote);
  //   }

  //   fetchDoctors();
  //   fetchDoctorsNoteTypes();
  //   editGeneralDoctorNotesModal.current.openModal();
  // }
const [mediaRecorder, setMediaRecorder] = useState(null);
const [audioBlob, setAudioBlob] = useState(null);
const [audioUrl, setAudioUrl] = useState("");
const [uploadedAudioName, setUploadedAudioName] = useState(null);
const [pendingAudioSave, setPendingAudioSave] = useState(false);
const [audioStream, setAudioStream] = useState(null);

  const editGeneralDoctorNotes = async () => {
  let updatedById;
  if (typeof DefaultDoctor === 'string') {
    const doctor = doctorData.find(d => d.fullname === DefaultDoctor);
    if (doctor) {
      updatedById = doctor.doctorid;
    }
  } else {
    updatedById = DefaultDoctor?.doctorid;
  }
  
  const inputToUpdate = {
    input: {
      appointmentid: appointmentId,
      doctorid: doctorId,
      patientid: patientid,
      updateddate: getLocalISOString(date, time),
      updatedby: updatedById,
      notetypeid: noteTypeId,
      audiourl: uploadedAudioName || localStorage.getItem('audioUrl') || undefined,
      id: generalEditNotesId,
      generalnote: updateGeneralDoctorNotes
    }
  }
  
  showLoader();
  try {
    const result = await AddDoctorNotes(inputToUpdate.input);
    
    // Clear transcriber and recording state
    clearTranscriberState();
    
    // Stop any active recording
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      mediaRecorder.stop();
    }
    if (audioStream) {
      audioStream.getTracks().forEach(track => track.stop());
      setAudioStream(null);
    }
    
    setUpdateGeneralDoctorNotes('');
    setValue("textField", "", {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: false,
    });
    
    showSuccessToast("Notes Updated Successfully");
    
    // Clear audio state
    setAudioBlob(null);
    setAudioUrl("");
    setUploadedAudioName(null);
    localStorage.removeItem('audioUrl');

    if (appointmentId) {
      fetchdoctornotesdata(patientid, appointmentId);
      setIsDateChanged(false);
    } else {
      fetchdoctornotesdata(patientid);
    }
    
    handleEditModalClose();
    
    return result;
  } catch (error) {
    console.log('Error in updating Doctor notes', error);
    throw error;
  } finally {
    dismissLoader();
  }
};
  // const editGeneralDoctorNotes = async () => {
  //   var formattedDate;
  //   console.log(date, "date in edit doctor notes")
  //   // if(!isDateChanged){
  //   //   formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
  //   // }else {
  //   //   formattedDate = date
  //   // }
  //   // console.log(formattedDate, "date in edit doctor notes")

  //   let updatedById;
  //   if (typeof DefaultDoctor === 'string') {
  //     const doctor = doctorData.find(d => d.fullname === DefaultDoctor);
  //     if (doctor) {
  //       updatedById = doctor.doctorid;
  //     }
  //   } else {
  //     updatedById = DefaultDoctor?.doctorid;
  //   }
  //   const inputToUpdate = {
  //     input: {
  //       appointmentid: appointmentId,
  //       doctorid: doctorId,
  //       "patientid": patientid,
  //       // updateddate:`${formattedDate}T${time}:00`,
  //       updateddate: getLocalISOString(date, time),
  //       updatedby: updatedById,
  //       notetypeid: noteTypeId,
  //       // generalnotedetail: [
  //       //   {
  //       //     generalnote: updateGeneralDoctorNotes,
  //       //   }
  //       // ]
  //       id: generalEditNotesId,
  //       generalnote: updateGeneralDoctorNotes
  //     }
  //   }
  //   showLoader();
  //   try {
  //     // const result = await EditDoctorNotes(inputToUpdate.input);
  //     const result = await AddDoctorNotes(inputToUpdate.input);
  //     setUpdateGeneralDoctorNotes('')
  //     showSuccessToast("Notes Updated Successfully")
  //     if (appointmentId) {
  //       fetchdoctornotesdata(patientid, appointmentId)
  //       setIsDateChanged(false);
  //     } else {
  //       fetchdoctornotesdata(patientid)

  //     }
  //     editGeneralDoctorNotesModal.current.closeModal();
  //     setIsEditModalOpen(false);
  //     return result;
  //   } catch (error) {
  //     console.log('Error in updating Dietician notes', error)
  //     throw error;
  //   } finally {
  //     dismissLoader();
  //   }
  // }
  // Update the modal close handlers
  // UPDATED handleEditModalClose function
// Update handleEditModalClose
const handleEditModalClose = () => {
  // Stop any active recording
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    mediaRecorder.stop();
  }
  if (audioStream) {
    audioStream.getTracks().forEach(track => track.stop());
  }
  
  // Clear transcriber state
  clearTranscriberState();
  
  // Reset all states
  setUpdateGeneralDoctorNotes("");
  setValue("textField", "", {
    shouldDirty: false,
    shouldTouch: false,
    shouldValidate: false,
  });
  setPlaceholder("Instructions");
  setSelectedLanguage('en-US');
  setInpLang("English");
  setOutputLang("English");
  setDefaultDoctor(null);
  setNoteType("Consultation Note");
  setNoteTypeId("");
  setGeneralEditNotesId(null);
  setIsRecording(false);
  
  // Clear audio states
  setAudioBlob(null);
  setAudioUrl("");
  setUploadedAudioName(null);
  localStorage.removeItem('audioUrl');
  
  // Clear media recorder
  setMediaRecorder(null);
  setAudioStream(null);
  
  setIsEditModalOpen(false);
  editGeneralDoctorNotesModal.current.closeModal();
};

// Add similar cleanup for add modal
const handleAddModalClose = () => {
  // Stop any active recording
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    mediaRecorder.stop();
  }
  if (audioStream) {
    audioStream.getTracks().forEach(track => track.stop());
  }
  
  // Clear transcriber state
  clearTranscriberState();
  
  // Clear audio states
  setAudioBlob(null);
  setAudioUrl("");
  setUploadedAudioName(null);
  localStorage.removeItem('audioUrl');
  
  // Clear media recorder
  setMediaRecorder(null);
  setAudioStream(null);
  
  setIsRecording(false);
};
// Add this useEffect for cleanup
useEffect(() => {
  return () => {
    // Cleanup function when component unmounts
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      mediaRecorder.stop();
    }
    if (audioStream) {
      audioStream.getTracks().forEach(track => track.stop());
    }
    // Revoke object URLs to prevent memory leaks
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
  };
}, [mediaRecorder, audioStream, audioUrl]);

// Add effect to monitor modal state
useEffect(() => {
  if (!isAddModalOpen && !isEditModalOpen) {
    // Clean up when modals are closed
    handleAddModalClose();
  }
}, [isAddModalOpen, isEditModalOpen]);

// const handleEditModalClose = () => {
//   // Reset all states
//   setUpdateGeneralDoctorNotes("");
//   setValue("textField", "");
//   setPlaceholder("Instructions");
//   setSelectedLanguage('en-US');
//   setInpLang("English");
//   setOutputLang("English");
//   setDefaultDoctor(null);
//   setNoteType("Consultation Note");
//   setNoteTypeId("");
//   setGeneralEditNotesId(null);
  
//   // Stop any ongoing recording
//   if (recorderRef.current && recorderRef.current.state === "recording") {
//     recorderRef.current.stop();
//   }
//   setIsRecording(false);
  
//   setIsEditModalOpen(false);
//   editGeneralDoctorNotesModal.current.closeModal();
// };

  // If user closes modal by other means ensure flags cleared: attach small helper
  const handleCloseAddModalManually = () => {
    // Stop any ongoing media recorder or stream
    try {
      if (mediaRecorder && mediaRecorder.state === "recording") {
        mediaRecorder.stop();
      }
      if (audioStream) {
        try { audioStream.getTracks().forEach(t => t.stop()); } catch (e) { /* ignore */ }
        setAudioStream(null);
      }
    } catch (e) {
      console.warn("Error stopping recording on modal close", e);
    }

    setIsAddModalOpen(false);
    addGeneralDoctorNotesModal.current?.closeModal?.();

    // Clear audio state
    setAudioBlob(null);
    setAudioUrl("");
    setUploadedAudioName(null);
    setPendingAudioSave(false);
    try { localStorage.removeItem('audioUrl'); } catch (e) { /* ignore */ }
  };
  const handleCloseEditModalManually = () => {
    setIsEditModalOpen(false);
    editGeneralDoctorNotesModal.current?.closeModal?.();
  };

  const openDeleteNotesModal = (id) => {
    setGeneralDeleteNotesId(id)
    deleteGeneralDoctorNotesModal.current.openModal();
  }
  const deleteGeneralDoctorNotes = async () => {
    const inputToUpdate = {
      input: {
        // appointmentid: appointmentId,
        // doctorid: doctorId,
        id: generalDeleteNotesId,
        // generalnote: updateGeneralDoctorNotes
      }
    }

    try {
      const result = await DeleteDoctorNotes(inputToUpdate.input);
      // fetchdoctornotesdata(patientid)
      if (appointmentId) {
        fetchdoctornotesdata(patientid, appointmentId)
      } else {
        fetchdoctornotesdata(patientid)

      }
      deleteGeneralDoctorNotesModal.current.closeModal();
      return result;
    } catch (error) {
      console.log('Error in updating Dietician notes', error)
      throw error;
    }
  }

  // waves 
  const recorderRef = useRef(null);
  const [chunks, setChunks] = useState([]);
  const [recording, setRecording] = useState(false);

  const [stream, setStream] = useState(null);

  useEffect(() => {
    if (recorderRef.current) return;

    if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          setStream(stream);

          recorderRef.current = new MediaRecorder(stream);
          // audioContextRef.current = new AudioContext({
          //   sampleRate: WHISPER_SAMPLING_RATE,
          // });

          recorderRef.current.onstart = () => {
            setRecording(true);
            setChunks([]);
          };
          recorderRef.current.ondataavailable = (e) => {
            if (e.data.size > 0) {
              setChunks((prev) => [...prev, e.data]);
            } else {
              setTimeout(() => {
                recorderRef.current.requestData();
              }, 25);
            }
          };

          recorderRef.current.onstop = () => {
            setRecording(false);
          };
        })
        .catch((err) => console.error("The following error occurred: ", err));
    } else {
      console.error("getUserMedia not supported on your browser!");
    }

    return () => {
      recorderRef.current?.stop();
      recorderRef.current = null;
    };
  }, []);


  // ------------------------------------
  //Remove speech and keep Null to toggle between GPU and Speech
  const [SelectedLanguage, setSelectedLanguage] = useState("en-US");
  const [inpLang, setInpLang] = useState("English");

  const handleChangeLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value; // Get the selected language
    setInpLang(selectedLanguage)
    const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found

    // Update the language in the transcriber
    setSelectedLanguage(languageCode);
    console.log("Selected Language: ", selectedLanguage);
    console.log("Language Code: ", languageCode);
  };

  const [outLang, setOutputLang] = useState("English")
  const handleChangeOutputLanguage = (selectedOption) => {
    const selectedLanguage = selectedOption.value;
    // const languageCode = languageCodeMap[selectedLanguage] || "en-US"; 

    // Update the language in the transcriber
    setOutputLang(selectedLanguage);
    console.log("Selected Language OUTPUT: ", selectedLanguage);
    // console.log("Language Code OUTPUT: ", languageCode);
  };
  // const handleChangeLanguage = (e) => {
  //   setSelectedLanguage("English")
  //   const selectedLanguage = e.value;
  //   setSelectedLanguage(selectedLanguage);
  //   console.log("SelectedLanguage: ", SelectedLanguage )

  //   const languageCode = languageCodeMap[selectedLanguage] || "en-US"; // Default to English (US) if not found
  //   setLanguageCode(languageCode);
  //   console.log("languageCode: ", LanguageCode )
  // };
  const language = 'hi-IN';
  // const onSpeechComplete = React.useCallback((text) => {
  //   // called when speech recognition finishes
  //   setPlaceholder(text || "");
  //   setTyping(false);
  // }, []);

  // const { transcriber: activeTranscriber, mode } =
  //   useHybridTranscriber("speech", onSpeechComplete, SelectedLanguage);

    const { transcriber: activeTranscriber, mode } =
      useHybridTranscriber("speech", (text) => {
        // called when speech recognition finishes
        setPlaceholder(text || "");
        setTyping(false);
    },
    SelectedLanguage
  );

  const [typing, setTyping] = useState(false); // Typing indicator state
  const [HPITextBox, SetHPITextBox] = useState("");

  const [placeholder, setPlaceholder] = useState(
    // "Click anywhere to start typing...."
    "Instructions"
  );
  const { register, handleSubmit, watch, setValue } = useForm();
  //   useEffect(() => {
  //     if (activeTranscriber?.output?.text) {
  //   const transcribedText = activeTranscriber.output.text;
  //   setValue("textField", transcribedText);
  //   setAddGeneralDoctorNotes(transcribedText); // Update the state with transcribed text
  //   setPlaceholder(""); // Clear the placeholder when text exists
  //   setTyping(false);
  // }
  //       // if (activeTranscriber?.output?.text) {
  //       //   setValue("textField", activeTranscriber.output.text);

  //       //   // setPlaceholder("Click anywhere to start typing....");
  //       //   setPlaceholder("Instructions");
  //       //   setTyping(false);
  //       // }
  //     }, [activeTranscriber?.output]);
  useEffect(() => {
  const out = activeTranscriber?.output?.text;
  
  // Only process if there's actual new output AND a modal is open
  if (!out || (!isAddModalOpen && !isEditModalOpen)) return;

  console.log('Transcriber output received:', out);
  console.log('Modal states - Add:', isAddModalOpen, 'Edit:', isEditModalOpen);

  // Only update if the output is different from current values
  if (isAddModalOpen) {
    const currentValue = addGeneralDoctorNotes;
    if (out !== currentValue) {
      setValue("textField", out);
      setAddGeneralDoctorNotes(out);
      setPlaceholder("");
      setTyping(false);
    }
  } else if (isEditModalOpen) {
    const currentValue = updateGeneralDoctorNotes;
    if (out !== currentValue) {
      setValue("textField", out);
      setUpdateGeneralDoctorNotes(out);
      setPlaceholder("");
      setTyping(false);
    }
  }
}, [activeTranscriber?.output?.text, isAddModalOpen, isEditModalOpen]);

  // useEffect(() => {
  //   const out = activeTranscriber?.output?.text;
  //   if (!out) return;

  //   // put transcription into the modal currently open
  //   setValue("textField", out);
  //   setPlaceholder("");
  //   setTyping(false);

  //   if (isAddModalOpen) {
  //     setAddGeneralDoctorNotes(out);
  //   } else if (isEditModalOpen) {
  //     // setUpdateGeneralDoctorNotes(out);
  //     setValue("textField", out);
  //   setUpdateGeneralDoctorNotes(out);
  //   setPlaceholder("");
  //   setTyping(false);
  //   } else {
  //     // fallback: update add field
  //     setAddGeneralDoctorNotes(out);
  //   }
  // }, [activeTranscriber?.output, isAddModalOpen, isEditModalOpen, setValue]);

  const calculateTextareaHeight = (text) => {
    const lineCount = text.split('\n').length;
    const baseHeight = 100; // Minimum height
    const lineHeight = 20; // Approximate pixels per line

    if (text.length === 0) {
      return "100px";
    } else if (lineCount <= 5) {
      return "150px";
    } else if (lineCount <= 15) {
      return "300px";
    } else {
      return "400px";
    }
  };
  // Handle text changes in the textarea
  // const handleTextChange = (e) => {
  //   const text = e.target.value;
  //   setAddGeneralDoctorNotes(text);
  //   setValue("textField", text); // Keep form value in sync
  //   setPlaceholder(text ? "" : "Instructions"); // Show placeholder only when empty
  // };
  // const handleEditTextChange = (e) => {
  //   const text = e.target.value;
  //   setUpdateGeneralDoctorNotes(e.target.value);
  //   setValue("textField", e.target.value);
  //   setPlaceholder(text ? "" : "Instructions"); // Show placeholder only when empty
  // };

  const handleEditTextChange = (e) => {
  const text = e.target.value;
  
  // Clear transcriber output when user types manually
  if (activeTranscriber && activeTranscriber.output) {
    activeTranscriber.output.text = "";
  }
  
  setUpdateGeneralDoctorNotes(text);
  setValue("textField", text, {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true,
  });
  setPlaceholder(text ? "" : "Instructions");
};

// UPDATED handleTextChange for add modal
const handleTextChange = (e) => {
  const text = e.target.value;
  
  // Clear transcriber output when user types manually
  if (activeTranscriber && activeTranscriber.output) {
    activeTranscriber.output.text = "";
  }
  
  setAddGeneralDoctorNotes(text);
  setValue("textField", text, {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true,
  });
  setPlaceholder(text ? "" : "Instructions");
};

// ADD this useEffect to monitor modal state changes
useEffect(() => {
  // When a modal closes, ensure transcriber is cleared
  if (!isAddModalOpen && !isEditModalOpen) {
    clearTranscriberState();
  }
}, [isAddModalOpen, isEditModalOpen]);


  const textFieldValue = watch("textField", "");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [initialText, setInitialText] = useState("");

  const onSubmit = (data) => {
    setIsButtonDisabled(true); // Disable button on submit
    // UpdateHpiTextBox(data);
    SetHPITextBox(data);
    // fetchDoctorNotesEmptyIndication();
  };

  // submit on tab switch and submit button is enalbed
  useEffect(() => {
    if (!isButtonDisabled) {
      handleSubmit(onSubmit)();
    }
  }, [])

  useEffect(() => {
    if (textFieldValue !== initialText) {
      setIsButtonDisabled(false); // Enable button if text field value changes
    } else {
      setIsButtonDisabled(true); // Disable button if text field value is unchanged
    }
  }, [textFieldValue, initialText]);

  const correctOrders = async (formType) => {
    const currentText = watch("textField");

    if (!currentText) {
      showErrorToast("No text available to correct");
      return;
    }

    // Include doctor specialties in the AI correction request
    const doctorSpecialties = DefaultDoctor?.specialties || "";

    // const inputToSave = {
    //   input: {
    //     text: currentText,
    //   },
    // };
    // console.log('doctorNotes doctorSpecialties', doctorSpecialties)
    // console.log('doctorNotes noteType', noteType)
    // console.log('doctorNotes noteTypeId', noteTypeId)
    const inputToSave = {
      input: {
        text: currentText,
        // type: "Doctor Notes",
        // type: `doctor_notes#${doctorSpecialties}#${noteType}#${doctorExperience}#${inpLang}#${outLang}`,
        type: `doctor_notes#${doctorSpecialties}#${doctorExperience}#${noteType}#${outLang}#${inpLang}`,
        //  speciality: doctorSpecialties
      },
    };

    showLoader();
    try {
      // const result = await CorrectChiefComplaintUsingAI(inputToSave.input);
      const result = await CorrectMedicalTermsUsingAI(inputToSave);
      if (result) {
        showSuccessToast("Updated Text");
        const updatedText = result?.text;

        // Update form value
        setValue("textField", updatedText, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });

        console.log('updatedText: ', updatedText)

        // Update the appropriate state based on form type
        if (formType === "add") {
          setAddGeneralDoctorNotes(updatedText);
        } else {
          // handleEditMedicineChange("custommessage", updatedText);
          setUpdateGeneralDoctorNotes(updatedText);
        }

        setPlaceholder("");
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.error("Error in Correct AI call:", error);
      // showErrorToast("Error Happened While Correcting.");
      showErrorToast("Error in Correct AI call.");
    } finally {
      dismissLoader();
    }
  };

  // ---------------------------- Discharge functionality
  const openDischargeModal = () => {
    // setAddGeneralDoctorNotes('')
    dischargePatientModal.current.openModal();
  }
  const handleDischargeNotes = async () => {
    const inputToSave = {
      input: {
        // doctorid: doctorId,
        patientid: patientid,
        appointmentid: appointmentId,
        completed: "3",
        dischargedate: new Date().toISOString(),
      },
    };

    try {
      const result = await DischargePatient(inputToSave.input);

      if (result?.output?.result == 'success') {
        fetchdoctornotesdata(patientid)
        showSuccessToast('Patient Discharged Successfully')
        dischargePatientModal.current.closeModal();
      }
      // return result;
    } catch (error) {
      console.error("Error in Add Doctor Notes:", error);
      throw error;
    }
  };

  // Add new state for doctor experience
  const [doctorExperience, setDoctorExperience] = useState("");
  // Add this helper function
  const getDoctorSpecialties = (doctor) => {
    if (!doctor || !doctor.doctorspeciality || doctor.doctorspeciality.length === 0) {
      return "";
    }

    const specialties = doctor.doctorspeciality.map(speciality => {
      if (speciality.specialityname === "Other" && speciality.othervalue) {
        return speciality.othervalue;
      }
      return speciality.specialityname;
    });

    return specialties.join(", ");
  };
  // Update the getDoctorSpecialties function to also handle experience
  const getDoctorDetails = (doctor) => {
    if (!doctor) return { specialties: "", experience: "" };

    // Get specialties
    const specialties = getDoctorSpecialties(doctor);

    // Get experience
    const experience = doctor.experience || "";

    return { specialties, experience };
  };
  // const fetchDoctors = async (shouldSetDefault = false) => {
  //   showLoader();
  //   try {
  //     const result = await FetchUsersByClinic({
  //       doctorId,
  //       appointmentid
  //     });
  //     if (result.output.result == "success") {
  //       const doctors = result.output.data;
  //       console.log('doctors: ', doctors)
  //       setDoctorData(doctors);
  //       const doctorNames = doctors.map((step) => step.fullname);
  //       setDoctorList(doctorNames);
  //         if (shouldSetDefault) {
  //         const currentDoctor = doctors.find(doc => doc.doctorid == doctorId);
  //         if (currentDoctor) {
  //           setDefaultDoctor(currentDoctor);
  //           console.log("Default doctor has been set:", currentDoctor);
  //         } else {
  //           console.log("Could not find the current doctor in the fetched list.", currentDoctor);
  //         }
  //       }
  //     } else {
  //       setDoctorList([]);
  //       dismissLoader();
  //     }
  //     dismissLoader();
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };

  const fetchDoctors = async (shouldSetDefault = false) => {
    showLoader();
    try {
      const result = await FetchUsersByClinic({
        doctorId,
        appointmentid
      });
      if (result.output.result == "success") {
        const doctors = result.output.data;
        console.log('doctors: ', doctors)
        setDoctorData(doctors);
        const doctorNames = doctors.map((step) => step.fullname);
        setDoctorList(doctorNames);

        if (shouldSetDefault) {
          const currentDoctor = doctors.find(doc => doc.doctorid == doctorId);
          if (currentDoctor) {
            // Add specialties and experience to the doctor object
            const doctorDetails = getDoctorDetails(currentDoctor);
            const doctorWithDetails = {
              ...currentDoctor,
              specialties: doctorDetails.specialties,
              experience: doctorDetails.experience
            };
            setDefaultDoctor(doctorWithDetails);
            // Also set doctorExperience state separately if needed
            setDoctorExperience(doctorDetails.experience);
            console.log("Default doctor has been set:", doctorWithDetails);
          } else {
            console.log("Could not find the current doctor in the fetched list.", currentDoctor);
          }
        }
      } else {
        setDoctorList([]);
        dismissLoader();
      }
      dismissLoader();
    } catch (error) {
      console.error("Error", error);
    }
  };

  //   const fetchDoctors = async (shouldSetDefault = false) => {
  //   showLoader();
  //   try {
  //     const result = await FetchUsersByClinic({
  //       doctorId,
  //       appointmentid
  //     });
  //     if (result.output.result == "success") {
  //       const doctors = result.output.data;
  //       console.log('doctors: ', doctors)
  //       setDoctorData(doctors);
  //       const doctorNames = doctors.map((step) => step.fullname);
  //       setDoctorList(doctorNames);

  //       if (shouldSetDefault) {
  //         const currentDoctor = doctors.find(doc => doc.doctorid == doctorId);
  //         if (currentDoctor) {
  //           // Add specialties to the doctor object
  //           const doctorWithSpecialties = {
  //             ...currentDoctor,
  //             specialties: getDoctorSpecialties(currentDoctor)
  //           };
  //           setDefaultDoctor(doctorWithSpecialties);
  //           console.log("Default doctor has been set:", doctorWithSpecialties);
  //         } else {
  //           console.log("Could not find the current doctor in the fetched list.", currentDoctor);
  //         }
  //       }
  //     } else {
  //       setDoctorList([]);
  //       dismissLoader();
  //     }
  //     dismissLoader();
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };

  // existing function
  // const HandleEditDoctor = (selectedOption)=>{
  //   let selectedDoctor = doctorData.filter(doctor => doctor.fullname == selectedOption);
  //   console.log(selectedOption, "selected doctor");
  //   if (selectedDoctor.length > 0) {
  //     console.log(selectedDoctor, "doctor");
  //     setDefaultDoctor(selectedDoctor[0].fullname);
  //   } else {
  //     setDefaultDoctor(null);
  //   }
  // }

  // newly added function
//   const HandleEditDoctor = (selectedDoctor) => {
//   console.log('Selected doctor:', selectedDoctor);
  
//   // Find the full doctor object from doctorData
//   const doctorObj = doctorData.find(doc => 
//     doc.doctorid === selectedDoctor.doctorid || 
//     doc.fullname === selectedDoctor.fullname
//   );
  
//   if (doctorObj) {
//     const doctorDetails = getDoctorDetails(doctorObj);
//     const doctorWithDetails = {
//       ...doctorObj,
//       specialties: doctorDetails.specialties,
//       experience: doctorDetails.experience
//     };
    
//     setDefaultDoctor(doctorWithDetails);
//     setDoctorExperience(doctorDetails.experience);
//     console.log('Doctor set with details:', doctorWithDetails);
//   } else {
//     // Fallback if not found
//     setDefaultDoctor(selectedDoctor);
//     setDoctorExperience("");
//   }
// };
  const HandleEditDoctor = (selectedOption) => {
    const selectedDoctor = doctorData.find(doctor => doctor.fullname === selectedOption);
    if (selectedDoctor) {
      const doctorDetails = getDoctorDetails(selectedDoctor);
      const doctorWithDetails = {
        ...selectedDoctor,
        specialties: doctorDetails.specialties,
        experience: doctorDetails.experience
      };
      setDefaultDoctor(doctorWithDetails);
      // Also update doctorExperience state when doctor changes
      setDoctorExperience(doctorDetails.experience);

      // const doctorWithSpecialties = {
      //     ...selectedDoctor,
      //     specialties: getDoctorSpecialties(selectedDoctor)
      //   };
      //   setDefaultDoctor(doctorWithSpecialties);
      // setDefaultDoctor(selectedDoctor);
    } else {
      setDefaultDoctor(null);
      setDoctorExperience("")
    }
  };
  // Helper function to format doctor display string (same as in dropdown component)
  const formatDoctorDisplayString = (doctor) => {
    if (!doctor) return "";

    // Only add "Dr." prefix if rolename is "Doctor"
    const shouldAddPrefix = doctor.rolename?.toLowerCase() === "doctor" &&
      !doctor.fullname?.toLowerCase().includes('dr.');

    const prefix = shouldAddPrefix ? 'Dr. ' : '';
    const displayName = `${prefix}${doctor.fullname || ''}`;

    // Get specialties
    let specialties = "";
    if (doctor.doctorspeciality && doctor.doctorspeciality.length > 0) {
      specialties = doctor.doctorspeciality.map(speciality => {
        if (speciality.specialityname === "Other" && speciality.othervalue) {
          return speciality.othervalue;
        }
        return speciality.specialityname;
      }).filter(specialty => specialty && specialty.trim() !== "").join(", ");
    }

    // Get role
    const role = doctor.rolename || "";

    let displayString = displayName;

    // Add specialties in brackets if available
    if (specialties && specialties.trim() !== "") {
      displayString += ` [${specialties}]`;
    }

    // Add role if available
    if (role && role.trim() !== "") {
      displayString += ` ${role}`;
    }

    return displayString;
  };

  // Get the display value for the dropdown
  const getDisplayValue = () => {
    if (!DefaultDoctor) return "";
    return formatDoctorDisplayString(DefaultDoctor);
  };
//   const getDisplayValue = () => {
//   if (!DefaultDoctor) return "";
  
//   // Check if DefaultDoctor is a string or object
//   if (typeof DefaultDoctor === 'string') {
//     return DefaultDoctor;
//   }
  
//   // If it's an object with fullname and specialties
//   if (DefaultDoctor.fullname && DefaultDoctor.specialties) {
//     return `${DefaultDoctor.fullname} [${DefaultDoctor.specialties}]`;
//   }
  
//   // Fallback to just the name
//   return DefaultDoctor.fullname || "";
// };

  const handledatechange = (selectedDate) => {
    // setIsDateChanged(true)
    // const formattedDate = format(selectedDate, "DD-MM-yyyy");
    const formattedDate = moment(selectedDate).format("DD-MM-yyyy");
    setDate(formattedDate);
  };

  const handleTimeChange = (event) => {
    const inputTime = event.target.value;
    const currentDate = moment().format("DD-MM-yyyy");
    const currentTime = moment().format("HH:mm");

    // Only validate if the selected date is today
    if (date === currentDate) {
      const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);

      // Create moment objects for comparison
      const inputMoment = moment().set({
        hour: inputHours,
        minute: inputMinutes,
        second: 0,
        millisecond: 0
      });

      const currentMoment = moment();

      if (inputMoment.isAfter(currentMoment)) {
        setTime(currentTime);
        showErrorToast("Future time cannot be selected.");
        return;
      }
    }

    // If date is not today or time is not in future, update the time
    setTime(inputTime);
  };

  // const handleEditTimeChange = (event) => {
  //   const inputTime = event.target.value;
  //   const currentDate = moment().format("DD-MM-yyyy");
  //   const currentTime = moment().format("HH:mm");

  //   // Only validate if the selected date in edit modal is today
  //   if (editHPIData.date === currentDate) {
  //     const [inputHours, inputMinutes] = inputTime.split(":").map(Number);
  //     const [currentHours, currentMinutes] = currentTime.split(":").map(Number);

  //     // Create moment objects for comparison
  //     const inputMoment = moment().set({
  //       hour: inputHours,
  //       minute: inputMinutes,
  //       second: 0,
  //       millisecond: 0
  //     });

  //     const currentMoment = moment();

  //     if (inputMoment.isAfter(currentMoment)) {
  //       const currentFormattedTime = moment().format("HH:mm");
  //       setEditHPIData(prev => ({...prev, time: currentFormattedTime}));
  //       showErrorToast("Future time cannot be selected.");
  //       return;
  //     }
  //   }

  //   // If date is not today or time is not in future, update the time
  //   setEditHPIData(prev => ({...prev, time: inputTime}));
  // };

  // const handleTimeChange = (event) => {
  //   const inputTime = event.target.value;
  //   console.log(inputTime, "input time");
  //   const currentTime = new Date();

  //   const inputDate = new Date();

  //   if (inputDate > currentTime) {

  //     setTime(moment().format("HH:mm"));
  //     showErrorToast("Future time cannot be selected.");
  //   } else {
  //     setTime(moment().format(inputTime,"HH:mm"));
  //   }
  // };

  const fetchDoctorsNoteTypes = async (shouldSetDefault = false) => {
    showLoader()
    try {
      var result = await FetchDoctorNoteType({
        "type": "notetype"
      });
      console.log('FetchNoteTYpes: ', result)
      if (result != null) {
        const formattedOptions = result.map(option => (
          [option.subtype]
        ));
        setNoteTypeData(formattedOptions);
        setNoteTypeCompleteData(result);

        // If we need to set default Consultation Note
        if (shouldSetDefault) {
          const consultationNote = result.find(item => item.subtype === "Consultation Note");
          if (consultationNote) {
            setNoteType("Consultation Note");
            setNoteTypeId(consultationNote.id);
          }
        }

        // If we're in edit mode and have a noteTypeId but no noteType, set it
        if (noteTypeId && !noteType) {
          const noteTypeObj = result.find(item => item.id === noteTypeId);
          if (noteTypeObj) {
            setNoteType(noteTypeObj.subtype);
            console.log('Setting note type from ID:', noteTypeObj.subtype);
          }
        }

        // Set default note type ID when data is loaded
        // const consultationNote = result.find(x => x.subtype === "Consultation Note");
        // if (consultationNote) {
        //   setNoteTypeId(consultationNote.id);
        // }
      }
      // setNoteTypeCompleteData(result);
      dismissLoader();
      return result; // Return result for use in openAddDoctornotesModal
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile")
    }
  }

  const handleNoteTypeinput = (selectedOption) => {
    var foundObject = noteTypeCompleteData && noteTypeCompleteData.find(x => x.subtype == selectedOption);

    if (foundObject) {
      setNoteTypeId(foundObject.id);
      setNoteType(selectedOption); // Update the note type state
    }
  }

  //   const fetchDoctorsNoteTypes = async ()=>{
  //      showLoader()
  //      try {
  //        var result = await FetchDoctorNoteType({
  //         "type":"notetype"
  //        });
  //        console.log('FetchNoteTYpes: ', result)
  //        if (result != null) {
  //         const formattedOptions = result.map(option => (
  //           [option.subtype]     
  //         ));
  //         //  setNoteTypeList(result)
  //         setNoteTypeData(formattedOptions);

  //       //    // If an id is already selected (e.g. edit modal opened), set the display value from list
  //       // if (noteTypeId) {
  //       //   const matched = result.find(r => Number(r.id) === Number(noteTypeId));
  //       //   if (matched) {
  //       //     setNoteType(matched.subtype);
  //       //   }
  //       // } else if (noteType) {
  //       //   // if we already have a subtype string, ensure it's normalized from the list (optional)
  //       //   const matchedByName = result.find(r => r.subtype === noteType);
  //       //   if (matchedByName) setNoteType(matchedByName.subtype);
  //       // }
  //        }
  //        setNoteTypeCompleteData(result);
  //        dismissLoader();
  //      } catch (error) {
  //        console.log(error, "Something went wrong in doctor profile")
  //      }
  //    }
  //    const handleNoteTypeinput= (selectedOption) =>{
  //   var foundObject = noteTypeCompleteData && noteTypeCompleteData.find(x => x.subtype == selectedOption);

  //   if (foundObject) {
  //     setNoteTypeId(foundObject.id)
  //   } 
  // }

  //    const selectNoteType = (selectedOption) => {
  //   const selectedType = NoteTypeList.find(item => item.subtype === selectedOption);
  //  console.log(selectedType , " Notetype")
  //   if (selectedType) {
  //     setNoteTypeId(selectedType.id);
  //   }

  // };

  // const selectNoteType = (selectedOption) => {
  //   console.log('selectedOption: ', selectedOption)
  //   if (!NoteTypeList || !Array.isArray(NoteTypeList)) {
  //     // fallback: just set display value
  //     setNoteType(selectedOption);
  //     setNoteTypeId(null);
  //     return;
  //   }
  //   const selectedType = NoteTypeList.find(item => item.subtype === selectedOption);
  //   if (selectedType) {
  //     setNoteTypeId(selectedType.id);
  //     setNoteType(selectedType.subtype);
  //   } else {
  //     // if user typed a value not in list
  //     setNoteType(selectedOption);
  //     setNoteTypeId(null);
  //   }
  // };
  // Function to get background color based on note type
  const getNoteTypeColor = (noteType) => {
    const colorMap = {
      'ER Note': '#FFE6E6', // Light red
      'Admission Note': '#E6F3FF', // Light blue
      'Pre-Operative Note': '#FFF2E6', // Light orange
      'Intra-Operative Note': '#F0E6FF', // Light purple
      'Post-Operative Note': '#E6FFF2', // Light green
      'Progress Note': '#FFFFE6', // Light yellow
      'Physiotherapy Note': '#E6F7FF', // Light cyan
      'Consultation Note': '#F5E6FF', // Light lavender
      'Nursing Note': '#E6FFFA', // Light mint
      'Discharge Summary Note': '#FFE6F2', // Light pink
    };
    return colorMap[noteType] || '#F9FAFB'; // Default color
  };

  // Function to get text color based on note type for better contrast
  const getNoteTypeTextColor = (noteType) => {
    const colorMap = {
      'ER Note': '#D63031', // Dark red
      'Admission Note': '#0984E3', // Dark blue
      'Pre-Operative Note': '#E17055', // Dark orange
      'Intra-Operative Note': '#6C5CE7', // Dark purple
      'Post-Operative Note': '#00B894', // Dark green
      'Progress Note': '#FDCB6E', // Dark yellow
      'Physiotherapy Note': '#00CEC9', // Dark cyan
      'Consultation Note': '#A29BFE', // Dark lavender
      'Nursing Note': '#00B894', // Dark mint
      'Discharge Summary Note': '#E84393', // Dark pink
    };
    return colorMap[noteType] || '#384052'; // Default color
  };

  //Multi Lingual Changes ------------------------------------------------------------

  const languageOptions = ['English', 'Hindi', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Urdu', 'Gujarati', 'Marathi', 'Punjabi', 'Bengali', 'Odia', 'Assamese', 'Nepali', 'Konkani', 'Sindhi', 'Kashmiri', 'Sanskrit', 'Dogri', 'Maithili', 'Santali', 'English (US)', 'English (UK)', 'Spanish (Spain)', 'French (France)', 'German (Germany)', 'Italian (Italy)', 'Chinese (Simplified)', 'Arabic (Standard)'];
  const languageCodeMap = {
    Hindi: "hi-IN",
    Bengali: "bn-IN",
    Tamil: "ta-IN",
    Telugu: "te-IN",
    Kannada: "kn-IN",
    Malayalam: "ml-IN",
    Gujarati: "gu-IN",
    Marathi: "mr-IN",
    Punjabi: "pa-IN",
    Urdu: "ur-IN",
    Assamese: "as-IN",
    Odia: "or-IN",
    Nepali: "ne-IN",
    Konkani: "kok-IN",
    Sindhi: "sd-IN",
    Kashmiri: "ks-IN",
    Sanskrit: "sa-IN",
    Dogri: "doi-IN",
    Maithili: "mai-IN",
    Santali: "sat-IN",
    "English (US)": "en-US",
    "English (UK)": "en-GB",
    "Spanish (Spain)": "es-ES",
    "French (France)": "fr-FR",
    "German (Germany)": "de-DE",
    "Italian (Italy)": "it-IT",
    "Chinese (Simplified)": "zh-CN",
    "Arabic (Standard)": "ar-SA",
  };

  // Add this state to your parent component
  const [isRecording, setIsRecording] = useState(false);

  // Add this state to track recording status properly
// const [isRecording, setIsRecording] = useState(false);


// Clear transcriber state function
const clearTranscriberState = () => {
  if (activeTranscriber && activeTranscriber.output) {
    activeTranscriber.output.text = "";
  }
  // Also stop any ongoing recording
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    mediaRecorder.stop();
  }
  if (audioStream) {
    audioStream.getTracks().forEach(track => track.stop());
    setAudioStream(null);
  }
};

// Upload recorded audio when ready
const uploadAndSaveAudio = async (audioBlob) => {
  if (!audioBlob) return;
  
  // Create filename with timestamp for uniqueness
  const timestamp = new Date().getTime();
  const filename = `audio_${timestamp}.webm`;
  const file = new File([audioBlob], filename, { type: "audio/webm" });
  
  try {
    const response = await uploadImageCommonFunction(file, filename);
    if (response && response.name) {
      localStorage.setItem("audioUrl", response.name);
      setUploadedAudioName(response.name);
      showSuccessToast && showSuccessToast("Audio uploaded successfully");
      return response.name; // Return the filename for use in save calls
    }
  } catch (e) {
    console.error("Error uploading audio:", e);
    showErrorToast && showErrorToast("Audio upload failed");
    return null;
  }
};

// Updated handleRecordingStateChange with proper cleanup
const handleRecordingStateChange = React.useCallback(async (recording) => {
  console.log('Recording state change to:', recording);
  
  // If trying to start recording when already recording, stop it first
  if (recording && isRecording) {
    console.log('Already recording, stopping first');
    await stopMediaRecorder();
    // Small delay before starting again
    await new Promise(resolve => setTimeout(resolve, 100));
  }
  
  if (recording) {
    await startMediaRecorder();
  } else {
    await stopMediaRecorder();
  }
  
  // Update state after the operation
  setIsRecording(recording);
}, [mediaRecorder, audioStream, isRecording]);

// Updated startMediaRecorder with better error handling
const startMediaRecorder = async () => {
  try {
    // Clear any existing audio
    setAudioBlob(null);
    setAudioUrl("");
    
    // Stop any existing recording
    if (mediaRecorder && mediaRecorder.state === 'recording') {
      await stopMediaRecorder();
    }
    
    // Stop any existing stream
    if (audioStream) {
      audioStream.getTracks().forEach(track => track.stop());
      setAudioStream(null);
    }
    
    // Get new audio stream
    const stream = await navigator.mediaDevices.getUserMedia({ 
      audio: {
        echoCancellation: true,
        noiseSuppression: true,
        sampleRate: 44100
      }
    });
    
    setAudioStream(stream);
    
    const recorder = new MediaRecorder(stream);
    const chunks = [];
    
    recorder.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        chunks.push(event.data);
      }
    };
    
    recorder.onstop = async () => {
      console.log('MediaRecorder stopped, chunks:', chunks.length);
      
      if (chunks.length > 0) {
        const audioBlob = new Blob(chunks, { type: 'audio/webm' });
        const url = URL.createObjectURL(audioBlob);
        
        setAudioBlob(audioBlob);
        setAudioUrl(url);
        
        // Auto-upload the recorded audio
        try {
          const audioUrl = await uploadAndSaveAudio(audioBlob);
          if (audioUrl) {
            setUploadedAudioName(audioUrl);
            localStorage.setItem('audioUrl', audioUrl);
          }
        } catch (uploadError) {
          console.error("Error uploading audio:", uploadError);
          showErrorToast && showErrorToast("Failed to upload audio");
        }
      }
      
      // Clean up stream
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
    
    recorder.onerror = (event) => {
      console.error('MediaRecorder error:', event.error);
      setIsRecording(false);
    };
    
    // Start recording with 1-second chunks
    recorder.start(1000);
    setMediaRecorder(recorder);
    setIsRecording(true);
    
    // Set timeout to auto-stop after 10 minutes (safety measure)
    setTimeout(() => {
      if (recorder.state === 'recording') {
        recorder.stop();
        setIsRecording(false);
      }
    }, 600000);
    
  } catch (error) {
    console.error("Error accessing microphone:", error);
    setIsRecording(false);
    showErrorToast && showErrorToast("Microphone access denied");
  }
};

// Updated stopMediaRecorder
const stopMediaRecorder = async () => {
  console.log('Stopping media recorder');
  
  if (mediaRecorder) {
    try {
      if (mediaRecorder.state === 'recording') {
        mediaRecorder.stop();
      }
      setMediaRecorder(null);
    } catch (error) {
      console.error('Error stopping media recorder:', error);
    }
  }
  
  // Also stop the stream
  if (audioStream) {
    audioStream.getTracks().forEach(track => track.stop());
    setAudioStream(null);
  }
  
  setIsRecording(false);
};

// Update the useEffect that monitors transcriber output
useEffect(() => {
  const out = activeTranscriber?.output?.text;
  
  if (!out || (!isAddModalOpen && !isEditModalOpen)) return;

  console.log('Transcriber output received:', out);
  
  // Clear transcriber output after processing
  if (activeTranscriber?.output) {
    const originalText = activeTranscriber.output.text;
    
    if (isAddModalOpen && out !== addGeneralDoctorNotes) {
      setValue("textField", out);
      setAddGeneralDoctorNotes(out);
      setPlaceholder("");
      setTyping(false);
    } else if (isEditModalOpen && out !== updateGeneralDoctorNotes) {
      setValue("textField", out);
      setUpdateGeneralDoctorNotes(out);
      setPlaceholder("");
      setTyping(false);
    }
    
    // Clear the transcriber output to prevent accumulation
    setTimeout(() => {
      if (activeTranscriber?.output) {
        activeTranscriber.output.text = "";
      }
    }, 100);
  }
}, [activeTranscriber?.output?.text, isAddModalOpen, isEditModalOpen]);

// Add cleanup effect for modals
useEffect(() => {
  // When modals close, clean up recording
  if (!isAddModalOpen && !isEditModalOpen) {
    forceStopRecording();
    
    // Clear audio state
    setAudioBlob(null);
    setAudioUrl("");
    setUploadedAudioName(null);
    localStorage.removeItem('audioUrl');
    
    // Clear transcriber
    if (activeTranscriber?.output) {
      activeTranscriber.output.text = "";
    }
  }
}, [isAddModalOpen, isEditModalOpen]);

// Add cleanup on component unmount
useEffect(() => {
  return () => {
    forceStopRecording();
    
    // Clean up object URLs
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
    }
  };
}, []);

// Add a function to manually stop recording (for safety)
const forceStopRecording = () => {
  if (mediaRecorder && mediaRecorder.state === 'recording') {
    mediaRecorder.stop();
  }
  if (audioStream) {
    audioStream.getTracks().forEach(track => track.stop());
    setAudioStream(null);
  }
  setIsRecording(false);
  setMediaRecorder(null);
};
  return (
    <>
      {isLoading && <Loader />}
      {/* {doctorNotesData && doctorNotesData!= null && doctorNotesData.length>0 ? ( */}
      <Box w="100%">
        {screenType == 'web' ? (
          <Box>
            <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
              <Text fontWeight='600'>Doctor Notes</Text>
              <Box display='flex' gap='1rem'>
                {/* <PrimaryButton
                fontSize="14px"
                variant="mdBtn"
                // btnIcon="/assets/imgs/add.png"
                buttonText="Discharge"
                onClick={openDischargeModal}
              /> */}
                <PrimaryButton
                  fontSize="14px"
                  variant="mdBtn"
                  btnIcon="/assets/imgs/add.png"
                  buttonText="Add Notes"
                  onClick={openAddDoctornotesModal}
                //   onClick={openAddConditionModal}
                //    isDisabled={actionAccessPatients?.create ? false : true}
                />
              </Box>
            </Box>
            <Box h='calc(100vh - 140px)' overflow='hidden auto' padding='1rem 1.5rem'>
              {/* newly added stepper */}
              <Stepper
                orientation="vertical"
                size="xs"
                colorScheme="#CDCFD4"
                gap="0"
                w="100%"
              >
                {doctorNotesData && doctorNotesData.length > 0 ? (
                  doctorNotesData.map((complaint, index) => {
                    // Function to get background color based on note type
                    const getNoteTypeColor = (noteType) => {
                      const colorMap = {
                        'ER Note': '#FFE6E6', // Light red
                        'Admission Note': '#E6F3FF', // Light blue
                        'Pre-Operative Note': '#FFF2E6', // Light orange
                        'Intra-Operative Note': '#F0E6FF', // Light purple
                        'Post-Operative Note': '#E6FFF2', // Light green
                        'Progress Note': '#FFFFE6', // Light yellow
                        'Physiotherapy Note': '#E6F7FF', // Light cyan
                        'Consultation Note': '#F5E6FF', // Light lavender
                        'Nursing Note': '#E6FFFA', // Light mint
                        'Discharge Summary Note': '#FFE6F2', // Light pink
                      };
                      return colorMap[noteType] || '#F9FAFB'; // Default color
                    };

                    // Function to get text color based on note type for better contrast
                    const getNoteTypeTextColor = (noteType) => {
                      const colorMap = {
                        'ER Note': '#D63031', // Dark red
                        'Admission Note': '#0984E3', // Dark blue
                        'Pre-Operative Note': '#E17055', // Dark orange
                        'Intra-Operative Note': '#6C5CE7', // Dark purple
                        'Post-Operative Note': '#00B894', // Dark green
                        'Progress Note': '#FDCB6E', // Dark yellow
                        'Physiotherapy Note': '#00CEC9', // Dark cyan
                        'Consultation Note': '#A29BFE', // Dark lavender
                        'Nursing Note': '#00B894', // Dark mint
                        'Discharge Summary Note': '#E84393', // Dark pink
                      };
                      return colorMap[noteType] || '#384052'; // Default color
                    };

                    //                     const getNoteTypeColor = (noteType) => {
                    //   const colorMap = {
                    //     'ER Note': 'linear-gradient(135deg, #FFE6E6 0%, #FFCCCC 100%)',
                    //     'Admission Note': 'linear-gradient(135deg, #E6F3FF 0%, #CCE6FF 100%)',
                    //     'Pre-Operative Note': 'linear-gradient(135deg, #FFF2E6 0%, #FFE6CC 100%)',
                    //     'Intra-Operative Note': 'linear-gradient(135deg, #F0E6FF 0%, #E6CCFF 100%)',
                    //     'Post-Operative Note': 'linear-gradient(135deg, #E6FFF2 0%, #CCFFE6 100%)',
                    //     'Progress Note': 'linear-gradient(135deg, #FFFFE6 0%, #FFFFCC 100%)',
                    //     'Physiotherapy Note': 'linear-gradient(135deg, #E6F7FF 0%, #CCF2FF 100%)',
                    //     'Consultation Note': 'linear-gradient(135deg, #F5E6FF 0%, #EBCCFF 100%)',
                    //     'Nursing Note': 'linear-gradient(135deg, #E6FFFA 0%, #CCFFF5 100%)',
                    //     'Discharge Summary Note': 'linear-gradient(135deg, #FFE6F2 0%, #FFCCE6 100%)',
                    //   };
                    //   return colorMap[noteType] || '#F9FAFB';
                    // };

                    // const getNoteTypeTextColor = (noteType) => {
                    //   const colorMap = {
                    //     'ER Note': '#C53030',
                    //     'Admission Note': '#2B6CB0',
                    //     'Pre-Operative Note': '#C05621',
                    //     'Intra-Operative Note': '#553C9A',
                    //     'Post-Operative Note': '#276749',
                    //     'Progress Note': '#B7791F',
                    //     'Physiotherapy Note': '#086F83',
                    //     'Consultation Note': '#6B46C1',
                    //     'Nursing Note': '#234E52',
                    //     'Discharge Summary Note': '#B83280',
                    //   };
                    //   return colorMap[noteType] || '#4A5568';
                    // };

                    return (
                      <Step w="100%" pb="1rem" key={index}>
                        <StepIndicator color="#E6E7E9" />

                        <Box flexShrink="0" w="95%">
                          <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                            <Box display="flex" gap="1.5rem" mr="1rem" justifyContent="space-between">
                              {appointmentid ? (
                                <Box>{complaint.updateddate != null ? formatDateTime(complaint.updateddate) : '-'}</Box>
                              ) : (
                                <Box>{complaint.createddate != null ? formatDate(complaint.createddate) : '-'}</Box>
                              )}

                              <Box display="flex" gap="1.5rem" flexDir="row" cursor="pointer">
                                <Box as="button">
                                  <Image
                                    src="/assets/svgs/edit.svg"
                                    w="1rem"
                                    h="auto"
                                    onClick={() => openEditNotesModal(complaint)}
                                  />
                                </Box>
                                <Box as="button">
                                  <Image
                                    src="/assets/svgs/delete.svg"
                                    w="14px"
                                    h="auto"
                                    onClick={() => openDeleteNotesModal(complaint.id)}
                                  />
                                </Box>
                              </Box>
                            </Box>
                          </StepTitle>
                          <StepDescription
                            bg="white"
                            w="100%"
                            border="1px solid #E6E7E9"
                            borderRadius="0.65rem"
                            p="0.75rem"
                          >
                            {/* Doctor Name, Specialty, and Note Type in one row */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb="0.5rem">
                              <Box display="flex" alignItems="baseline" gap="0.25rem" flexWrap="nowrap">
                                <Text fontWeight='700' fontSize="0.875rem" color="#384052" lineHeight="1">
                                  {complaint.doctorname}
                                </Text>
                                <Text fontSize="0.875rem" color="#384052" lineHeight="1">,</Text>
                                <Text
                                  fontSize="0.75rem"
                                  fontWeight="600"
                                  color="#6B7280"
                                  ml="0.25rem"
                                  lineHeight="1"
                                >
                                  {complaint.specality || complaint.specialization}
                                </Text>
                              </Box>

                              {/* Note Type with colored background */}
                              <Box
                                bg={getNoteTypeColor(complaint.codevalue)}
                                color={getNoteTypeTextColor(complaint.codevalue)}
                                px="0.75rem"
                                py="0.25rem"
                                borderRadius="12px"
                                fontSize="0.7rem"
                                fontWeight="600"
                                border={`1px solid ${getNoteTypeTextColor(complaint.codevalue)}20`}
                              >
                                {complaint.codevalue}
                              </Box>
                            </Box>

                            {/* Note Content */}
                            <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem" borderRadius="4px">
                              <Text fontSize="0.875rem" fontWeight="500" color="#384052">
                                {complaint.generalnote}
                              </Text>

                              {/* Playback for saved audio on note */}
                              {complaint.audiourl && (
                                <Box mt="8px" p="6px" bg="#E8F8FF" borderRadius="6px">
                                  <Box display="flex" alignItems="center" justifyContent="space-between" mb="4px">
                                    <Text fontSize="0.75rem" fontWeight="600">🎧 Recorded Audio</Text>
                                  </Box>
                                  <audio
                                    controls
                                    // src={complaint.imagepath ? complaint.imagepath + complaint.audiourl : complaint.audiourl}
                                    src={audioPath ? audioPath + complaint.audiourl : complaint.audiourl}
                                    style={{ width: '100%', height: '30px', borderRadius: '4px' }}
                                  />
                                </Box>
                              )}
                            </Box>
                          </StepDescription>
                        </Box>
                        <StepSeparator colorScheme="red" />
                      </Step>
                    );
                  })
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    h="calc(100vh - 100px)"
                    w="100%"
                  >
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/cheif-complaint.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}
              </Stepper>

              {/* existing stepper */}
              {/* <Stepper
                orientation="vertical"
                // height="400px"
                size="xs"
                colorScheme="#CDCFD4"
                gap="0"
                w="100%"
              >
                {doctorNotesData && doctorNotesData.length > 0 ? (
                  doctorNotesData.map((complaint, index) => (
                    <Step w="100%" pb="1rem" key={index}>
                      <StepIndicator color="#E6E7E9" />

                      <Box flexShrink="0" w="95%">
                        <StepTitle fontSize="0.75rem" fontWeight="500" color="#384052" mb="0.5rem">
                          <Box display="flex" gap="1.5rem" mr="1rem" justifyContent="space-between">
                            {appointmentid ? (
                              <Box>{complaint.updateddate != null ? formatDateTime(complaint.updateddate) : '-'}</Box>
                            ) : (
                              <Box>{complaint.createddate != null ? formatDate(complaint.createddate) : '-'}</Box>
                            )}

                            <Box display="flex" gap="1.5rem" flexDir="row" cursor="pointer">
                              <Box as="button"
                               disabled={!actionAccessPatients?.update} 
                               opacity={actionAccessPatients?.update ? 1 : 0.5}
                              >
                                <Image
                                  src="/assets/svgs/edit.svg"
                                  w="1rem"
                                  h="auto"
                                  onClick={() =>
                                    openEditNotesModal(
                                      complaint
                                    )
                                  }
                                />
                              </Box>
                              <Box as="button" 
                              disabled={!actionAccessPatients?.delete} 
                              opacity={actionAccessPatients?.delete ? 1 : 0.5}
                              >
                                <Image
                                  src="/assets/svgs/delete.svg"
                                  w="14px"
                                  h="auto"
                                  onClick={() => openDeleteNotesModal(complaint.id)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </StepTitle>
                        <StepDescription
                          bg="white"
                          w="100%"
                          border="1px solid #E6E7E9"
                          borderRadius="0.65rem"
                          p="0.75rem"
                        >
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.1rem">
                            {`${complaint.doctorname}`}
                          </Text>
                          <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{complaint.specialization}</Text>
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052">{complaint.codevalue}</Text>

                          <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                            <Text fontSize="0.875rem" fontWeight="500">
                              {complaint.generalnote}
                            </Text>
                          </Box>
                        </StepDescription>
                      </Box>
                      <StepSeparator colorScheme="red" />

                    </Step>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    h="calc(100vh - 100px)"
                    w="100%"
                  >
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/cheif-complaint.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}

              </Stepper> */}
            </Box>
          </Box>
        ) : (
          ///Mobile responsive
          <Box w="100%">
            <MobileSecondaryNav
              header="Doctor Notes"
              handlebackarrow={backFunction}
            />
            <Box h="calc(100vh - 120px)" overflow="hidden auto" p="1rem">
              <Stepper
                orientation="vertical"
                height="400px"
                size="xs"
                colorScheme="#CDCFD4"
                gap="0"
                w="100%"
              >
                {doctorNotesData && doctorNotesData.length > 0 ? (
                  doctorNotesData.map((complaint, index) => (
                    <Step w="100%" pb="1rem" key={index}>
                      <StepIndicator color="#E6E7E9" />

                      <Box flexShrink="0" w="95%">
                        <StepTitle as="div">
                          {/* 10th Jan, 2024 */}
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{formatDate(complaint.appointmentdate)}</Text>

                        </StepTitle>
                        <StepDescription
                          bg="white"
                          w="100%"
                          border="1px solid #E6E7E9"
                          borderRadius="0.65rem"
                          p="0.75rem"
                        >
                          <Text fontWeight='600' fontSize="0.875rem" color="#384052" mb="0.5rem">{`${complaint.doctorname} , ${complaint.bookingid}`}</Text>
                          <Text fontSize="0.875rem" color="#384052" mb="0.5rem">{complaint.specialization}</Text>
                          {/* <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      p="0.5rem"
                      pl="0"
                    >
                      <Text fontSize="0.875rem" color="#061027">
                        Visited general physician
                        {complaint.doctorname}
                      </Text>
                      <Image src="/assets/imgs/right-icon.png" />
                    </Box> */}
                          <Box bg="#F9FAFB" borderLeft="2px solid #14C585" p="0.5rem">
                            <Text fontSize="0.875rem" fontWeight="500">
                              {/* Reason: Headache, stomach ache, coughing and vomiting */}
                              {complaint.chiefcomplaint}
                            </Text>
                          </Box>
                          {/* <Box display="flex" p="0.5rem" pl="0" alignItems="center">
                      <Image w="0.75rem" h="auto" src="/assets/svgs/update.svg" />
                      <Text
                        fontSize="0.875rem"
                        fontWeight="500"
                        color="#6A707D"
                        pl="0.5rem"
                      >
                        Reason: Headache, stomach ache, coughing and vomiting
                        {''}
                      </Text>
                    </Box> */}
                        </StepDescription>
                      </Box>
                      <StepSeparator colorScheme="red" />

                    </Step>
                  ))
                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    h="calc(100vh - 100px)"
                    w="100%"
                  >
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/cheif-complaint.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data available
                    </Text>
                  </Box>
                )}

              </Stepper>
            </Box>
          </Box>
        )}
      </Box>
      {/* // ) : ( */}

      {doctorNotesData && doctorNotesData == null && doctorNotesData.length > 0 && (
        <Box w='100%'>
          <Box pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
            <Text fontWeight='600'>Doctor Notes</Text>
            <PrimaryButton
              fontSize="14px"
              variant="mdBtn"
              btnIcon="/assets/imgs/add.png"
              buttonText="Add Notes"
            // onClick={openAddDoctornotesModal(item.generalnote)}
            //         onClick={() =>
            //   openAddDoctornotesModal(
            //     item.id,
            //     "add",
            //     item.generalnote
            //   )
            // }
            // isDisabled={actionAccessPatients?.create ? false : true}
            />
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            gap="10px"
            alignItems="center"
            h="calc(100vh - 100px)"
            w="100%"
          >
            <Box textAlign="left" fontSize="16px" fontWeight="600">
              <Image
                w="26px"
                opacity="0.5"
                src="/assets/imgs/medical-history.png"
              />
            </Box>
            <Text textAlign="left" fontSize="12px" fontWeight="500">
              No Data available
            </Text>
          </Box>
        </Box>

      )}

      <DynamicModal
        ref={dynamicModal}
        modalHeader="Delete condition?"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              {/* Are you sure you want to delete "{condition}" */}
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
            // onClick={deleteMedicalCondition}
            />
          </>
        }
      />

      {/* Delete general dietician notes */}
      <DynamicModal
        ref={deleteGeneralDoctorNotesModal}
        modalHeader={`Delete Dietician Notes?`}
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to Delete General Doctor Notes
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                deleteGeneralDoctorNotes();
              }}
            />
          </>
        }
      />

      {/* Add general dietician notes */}
      <DynamicModal
        ref={addGeneralDoctorNotesModal}
        modalHeader={`Add Doctor Notes`}
        footerStyle={{ p: "0.5rem 1rem" }}
        modalBodyStyle={{ p: "1rem" }}
        modalWidth='1100px'
        modalBody={
          <>
            {appointmentid && (
              <>
                {/* First Row: Doctor Name, Date, Time */}
                <Flex gap="0" mb="0.75rem">
                  <DropdownInputDoctorList
                    variant="leftSide"
                    dropDownPlace="Doctor Name"
                    options={DoctorList}
                    id="Doctor Name"
                    onClick={HandleEditDoctor}
                    // value={DefaultDoctor?.fullname || ""} 
                    // inputValue={DefaultDoctor?.fullname || ""}
                    value={getDisplayValue()} // Use formatted display value
                    inputValue={getDisplayValue()} // Use formatted display value
                    menuList={{ pos: "absolute", right: "-41px", minW: "550px" }}
                    inputStyleCss={{ w: "100%" }}
                    doctorData={doctorData}
                    isDoctorDropdown={true}
                  />

                  <Box display="flex" flexDir="row" w="50%" gap="0">
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handledatechange(selectedDateValue)
                      }
                      defaultDate={date}
                      disableFutureDates={true}
                      placeholderProp="Date"
                      calendarStlye={{ left: "-18px", right: "unset" }}
                      datePickerInputStyle={{ borderRadius: '0' }}
                    />

                    <PrimaryInput
                      variant="rightSide"
                      id="vitaltime"
                      inputType="time"
                      inputPlace="Time"
                      pr="10px"
                      defaultValue={time}
                      inputValue={time}
                      onChange={handleTimeChange}
                    />
                  </Box>
                </Flex>

                {/* Note Type Radio Buttons */}
                <Flex my='0.75rem' w='100%' flexDirection="column">
                  <RadioGroup
                    value={noteType || "Consultation Note"}
                    onChange={(value) => handleNoteTypeinput(value)}
                    display='flex'
                    alignItems='center'
                    gap='0.75rem'
                    flexWrap='wrap'
                  >
                    {noteTypeCompleteData && noteTypeCompleteData.map((noteTypeItem) => {
                      const isSelected = noteType === noteTypeItem.subtype;
                      const backgroundColor = getNoteTypeColor(noteTypeItem.subtype);
                      const textColor = getNoteTypeTextColor(noteTypeItem.subtype);

                      return (
                        <Box
                          as="label"
                          key={noteTypeItem.id}
                          display="flex"
                          alignItems="center"
                          cursor="pointer"
                          position="relative"
                        >
                          <Radio
                            colorScheme="green"
                            value={noteTypeItem.subtype}
                            opacity="0"
                            position="absolute"
                            width="100%"
                            height="100%"
                            cursor="pointer"
                            zIndex="1"
                          />

                          <Box
                            bg={backgroundColor}
                            color={textColor}
                            border={isSelected ? "2px solid" : "1px solid"}
                            borderColor={isSelected ? textColor : "#E2E8F0"}
                            borderRadius="8px"
                            px="1rem"
                            py="0.5rem"
                            fontSize={isSelected ? "0.95rem" : "0.875rem"}
                            fontWeight={isSelected ? "700" : "500"}
                            transition="all 0.2s ease"
                            _hover={{
                              transform: "translateY(-1px)",
                              boxShadow: "sm"
                            }}
                            boxShadow={isSelected ? "0 2px 4px rgba(0,0,0,0.1)" : "none"}
                            transform={isSelected ? "translateY(-1px)" : "none"}
                            cursor="pointer"
                            userSelect="none"
                          >
                            {noteTypeItem.subtype}
                          </Box>
                        </Box>
                      );
                    })}
                  </RadioGroup>
                </Flex>
              </>
            )}

            {/* Textarea Section */}
            <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
              <Box
                as="form"
                width='100%'
                bg="white"
              >
                <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                  <Textarea
                    borderRadius='0'
                    {...register("textField")}
                    value={addGeneralDoctorNotes}
                    onChange={handleTextChange}
                    minH="100px"
                    height={addGeneralDoctorNotes ? "250px" : "250px"}
                    padding="2"
                    resize="none"
                    style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                  />

                  {!addGeneralDoctorNotes && (
                    <Text
                      position="absolute"
                      bottom="2"
                      left="50%"
                      transform="translateX(-50%)"
                      fontSize="sm"
                      color="gray.500"
                      w={{ base: "100%", md: "unset" }}
                      textAlign={{ base: "center", md: "unset" }}
                    >
                      {placeholder}
                    </Text>
                  )}
                </Box>
              </Box>
            </Box>

            {/* Audio & Language Controls Row - Highlighted Section */}
            <Box
              bg="#f8f9fa"
              border="1px solid #e9ecef"
              borderRadius="8px"
              p="1rem"
              mt="1rem"
            // mb="1rem"
            >
              <Flex
                alignItems="center"
                justifyContent="space-around"
                // justifyContent="space-between"
                gap="1rem"
                flexWrap={{ base: "wrap", md: "nowrap" }}
              >
                {/* Input Language Dropdown */}
                <Box flex="1" minW="120px">
                  <DropdownWithMultiLingual
                    menuList={{ pos: 'relative', right: '75px' }}
                    placeholder="English"
                    onClick={handleChangeLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Input Language"
                  />
                </Box>

                {/* Audio Controls and Wave Display */}
                <Box
                  flex="1"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap="0.75rem"
                  minH="50px"
                  px="1rem"
                >
                  <GPUChatAudioManagerSpeechMode
                    transcriber={activeTranscriber}
                    mode={mode}
                    setPlaceholder={setPlaceholder}
                    setTyping={setTyping}
                    onRecordingStateChange={handleRecordingStateChange}
                    isRecording={isRecording} // Pass recording state
                    // onRecordingComplete={handleGPURecordingComplete}
                  />

                  {isRecording && (
                    <Box flex="1" minW="180px" maxW="250px">
                      <AudioDisplayForClutter
                        borderRadius="lg"
                        stream={stream}
                        width="100%"
                      />
                    </Box>
                  )}
                </Box>

                {/* Playback for recorded/loaded audio */}
                {/* <Box flex="1" display="flex" alignItems="center" justifyContent="center" gap="0.5rem" minW="180px">
                  {audioUrl && (
                    <>
                      <audio controls ref={audioPlayerRef} src={audioUrl} style={{ width: '220px' }} />
                      <button
                        type="button"
                        onClick={() => {
                          if (audioPlayerRef.current) {
                            if (audioPlayerRef.current.paused) audioPlayerRef.current.play();
                            else audioPlayerRef.current.pause();
                          }
                        }}
                      >
                        Play/Pause
                      </button>
                    </>
                  )}
                </Box> */}

                {/* Output Language Dropdown */}
                <Box flex="1" minW="120px">
                  <DropdownWithMultiLingual
                    menuList={{ pos: 'relative', right: '75px' }}
                    placeholder="English"
                    onClick={handleChangeOutputLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Output Language"
                  />
                </Box>

                {/* AI Correction Button */}
                <Box
                  as="button"
                  type="button"
                  border="1px solid #E6E7E9"
                  borderRadius="full"
                  w="40px"
                  h="40px"
                  p="8px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  cursor={textFieldValue ? "pointer" : "not-allowed"}
                  opacity={textFieldValue ? 1 : 0.5}
                  pointerEvents={textFieldValue ? "auto" : "none"}
                  onClick={() => textFieldValue && correctOrders("add")}
                  flexShrink="0"
                  bg="white"
                  _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                >
                  <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                </Box>
              </Flex>
            </Box>
            {/* <Box flex="1" display="flex" alignItems="center" justifyContent="center" gap="0.5rem" minW="180px">
                  {audioUrl && (
                    <>
                      <audio controls ref={audioPlayerRef} src={audioUrl} style={{ width: '220px' }} />
                      <button
                        type="button"
                        onClick={() => {
                          if (audioPlayerRef.current) {
                            if (audioPlayerRef.current.paused) audioPlayerRef.current.play();
                            else audioPlayerRef.current.pause();
                          }
                        }}
                      >
                        Play/Pause
                      </button>
                    </>
                  )}
                </Box> */}
          </>
        }
        modalFooterBtn={
          <HStack width="100%" justifyContent="flex-end">
            <PrimaryButton
              buttonText="Add notes"
              btnStyle={{
                w: "auto",
                h: "2.5rem",
                px: "2rem",
              }}
              onClick={addDoctorNotes}
            />
          </HStack>
        }
      />



      {/* Update general dietician notes */}
      {/* Update general dietician notes */}
      <DynamicModal
        ref={editGeneralDoctorNotesModal}
        modalHeader={`Update Doctor Notes`}
        modalWidth='1100px'
        footerStyle={{ p: "0.5rem 1rem" }}
        modalBody={
          <>
            {appointmentid && (
              <>
                {/* First Row: Doctor Name, Date, Time */}
                <Flex gap="0" mb="0.75rem">
                  {/* <DropdownInput
              variant="leftSide"
              dropDownPlace="Doctor Name"
              options={DoctorList}
              id="Doctor Name"
              onClick={HandleEditDoctor}
              value={DefaultDoctor?.fullname ?? DefaultDoctor}
              menuList={{ pos: "absolute", right: "-41px", minW: "310px" }}
              inputStyleCss={{w: "100%"}}
            /> */}
            <DropdownInputDoctorList
  variant="leftSide"
  dropDownPlace="Doctor Name"
  options={DoctorList}
  id="Doctor Name"
  onClick={HandleEditDoctor}
  value={getDisplayValue()}
  menuList={{ pos: "absolute", right: "-41px", minW: "550px" }}
  inputStyleCss={{ w: "100%" }}
  doctorData={doctorData}
  isDoctorDropdown={true}
  // Add these props to ensure proper display
  // getOptionLabel={(option) => {
  //   if (option.specialties) {
  //     return `${option.fullname} [${option.specialties}]`;
  //   }
  //   return option.fullname || option;
  // }}
  // getOptionValue={(option) => option.doctorid || option}
/>
                  {/* <DropdownInputDoctorList
                    variant="leftSide"
                    dropDownPlace="Doctor Name"
                    options={DoctorList}
                    id="Doctor Name"
                    onClick={HandleEditDoctor}
                    // value={DefaultDoctor?.fullname ?? DefaultDoctor}
                    value={getDisplayValue()}
                    menuList={{ pos: "absolute", right: "-41px", minW: "550px" }}
                    inputStyleCss={{ w: "100%" }}
                    doctorData={doctorData} // Pass doctor data
                    isDoctorDropdown={true} // Identify as doctor dropdown
                  /> */}


                  <Box display="flex" flexDir="row" w="50%" gap="0">
                    <DatePicker
                      onDateChange={(selectedDateValue) =>
                        handledatechange(selectedDateValue)
                      }
                      defaultDate={date}
                      disableFutureDates={true}
                      placeholderProp="Date"
                      calendarStlye={{ left: "-18px", right: "unset" }}
                      datePickerInputStyle={{ borderRadius: '0' }}
                    />

                    <PrimaryInput
                      variant="rightSide"
                      id="vitaltime"
                      inputType="time"
                      inputPlace="Time"
                      pr="10px"
                      defaultValue={time}
                      inputValue={time}
                      onChange={handleTimeChange}
                    />
                  </Box>
                </Flex>

                {/* Second Row: Note Type Radio Buttons */}
                {/* <Flex my='0.75rem' w='100%' flexDirection="column">
            <Text fontSize="0.875rem" fontWeight="600" color="#384052" mb="0.5rem">
              Note Type
            </Text>
            <RadioGroup 
              value={noteType || ""}
              onChange={(value) => handleNoteTypeinput(value)}
              display='flex' 
              alignItems='center' 
              gap='0.75rem'
              flexWrap='wrap'
            >
              {noteTypeCompleteData && noteTypeCompleteData.map((noteTypeItem) => {
                const isSelected = noteType === noteTypeItem.subtype;
                return (
                  <Box 
                    as="label"
                    key={noteTypeItem.id} 
                    display="flex" 
                    alignItems="center"
                    cursor="pointer"
                  >
                    <Radio 
                      colorScheme="green" 
                      value={noteTypeItem.subtype}
                      size={isSelected ? "lg" : "md"}
                    />
                    <Text
                      fontSize={isSelected ? "0.95rem" : "0.875rem"}
                      fontWeight={isSelected ? "700" : "500"}
                      color={isSelected ? "#2D3748" : "#4A5568"}
                      ml="0.5rem"
                    >
                      {noteTypeItem.subtype}
                    </Text>
                  </Box>
                );
              })}
            </RadioGroup>
          </Flex> */}

                <Flex my='0.75rem' w='100%' flexDirection="column">
                  <Text fontSize="0.875rem" fontWeight="600" color="#384052" mb="0.5rem">
                    Note Type
                  </Text>
                  <RadioGroup
                    value={noteType || ""}
                    onChange={(value) => handleNoteTypeinput(value)}
                    display='flex'
                    alignItems='center'
                    gap='0.75rem'
                    flexWrap='wrap'
                  >
                    {noteTypeCompleteData && noteTypeCompleteData.map((noteTypeItem) => {
                      const isSelected = noteType === noteTypeItem.subtype;
                      const backgroundColor = getNoteTypeColor(noteTypeItem.subtype);
                      const textColor = getNoteTypeTextColor(noteTypeItem.subtype);

                      return (
                        <Box
                          as="label"
                          key={noteTypeItem.id}
                          display="flex"
                          alignItems="center"
                          cursor="pointer"
                          position="relative"
                        >
                          {/* Hidden radio for functionality */}
                          <Radio
                            colorScheme="green"
                            value={noteTypeItem.subtype}
                            opacity="0"
                            position="absolute"
                            width="100%"
                            height="100%"
                            cursor="pointer"
                            zIndex="1"
                          />

                          {/* Colored button appearance */}
                          <Box
                            bg={backgroundColor}
                            color={textColor}
                            border={isSelected ? "2px solid" : "1px solid"}
                            borderColor={isSelected ? textColor : "#E2E8F0"}
                            borderRadius="8px"
                            px="1rem"
                            py="0.5rem"
                            fontSize={isSelected ? "0.95rem" : "0.875rem"}
                            fontWeight={isSelected ? "700" : "500"}
                            transition="all 0.2s ease"
                            _hover={{
                              transform: "translateY(-1px)",
                              boxShadow: "sm"
                            }}
                            boxShadow={isSelected ? "0 2px 4px rgba(0,0,0,0.1)" : "none"}
                            transform={isSelected ? "translateY(-1px)" : "none"}
                            cursor="pointer"
                            userSelect="none"
                          >
                            {noteTypeItem.subtype}
                          </Box>
                        </Box>
                      );
                    })}
                  </RadioGroup>
                </Flex>
              </>
            )}

            <Box position='relative' display='flex' alignItems='flex-end' flexDirection='row'>
              <Box
                as="form"
                width='100%'
                bg="white"
                pt={"2px"}
              >
                <Box flex="1" width="100%" position="relative" bg={"#f9fafb"}>
                  <Textarea
                    borderRadius='0'
                    {...register("textField")}
                    value={updateGeneralDoctorNotes}
                    onChange={handleEditTextChange}
                    height={updateGeneralDoctorNotes ? "250px" : "250px"}
                    minH="100px"
                    padding="2"
                    resize="none"
                    style={{ overflowWrap: "break-word", whiteSpace: "pre-wrap" }}
                  />

                  {!updateGeneralDoctorNotes && (
                    <Text
                      position="absolute"
                      bottom="2"
                      left="50%"
                      transform="translateX(-50%)"
                      fontSize="sm"
                      color="gray.500"
                      w={{ base: "100%", md: "unset" }}
                      textAlign={{ base: "center", md: "unset" }}
                    >
                      {placeholder}
                    </Text>
                  )}
                </Box>
              </Box>
            </Box>

            {/* Audio & Language Controls Row - Highlighted Section */}
            <Box
              bg="#f8f9fa"
              border="1px solid #e9ecef"
              borderRadius="8px"
              p="1rem"
              mt="1rem"
            // mb="1rem"
            >
              <Flex
                alignItems="center"
                justifyContent="space-around"
                // justifyContent="space-between"
                gap="1rem"
                flexWrap={{ base: "wrap", md: "nowrap" }}
              >
                {/* Input Language Dropdown */}
                <Box flex="1" minW="120px">
                  <DropdownWithMultiLingual
                    menuList={{ pos: 'relative', right: '75px' }}
                    placeholder="English"
                    onClick={handleChangeLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Input Language"
                  />
                </Box>

                {/* Audio Controls and Wave Display */}
                <Box
                  flex="1"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap="0.75rem"
                  minH="50px"
                  px="1rem"
                >
                  <GPUChatAudioManagerSpeechMode
                    transcriber={activeTranscriber}
                    mode={mode}
                    setPlaceholder={setPlaceholder}
                    setTyping={setTyping}
                    onRecordingStateChange={handleRecordingStateChange}
                    isRecording={isRecording} // Pass recording state
                    // onRecordingComplete={handleGPURecordingComplete}
                  />

                  {isRecording && (
                    <Box flex="1" minW="180px" maxW="250px">
                      <AudioDisplayForClutter
                        borderRadius="lg"
                        stream={stream}
                        width="100%"
                      />
                    </Box>
                  )}
                </Box>

                {/* Playback for recorded/loaded audio in Edit modal */}
                {/* <Box flex="1" display="flex" alignItems="center" justifyContent="center" gap="0.5rem" minW="180px">
                  {audioUrl && (
                    <>
                      <audio controls ref={audioPlayerRef} src={audioUrl} style={{ width: '220px' }} />
                      <button
                        type="button"
                        onClick={() => {
                          if (audioPlayerRef.current) {
                            if (audioPlayerRef.current.paused) audioPlayerRef.current.play();
                            else audioPlayerRef.current.pause();
                          }
                        }}
                      >
                        Play/Pause
                      </button>
                    </>
                  )}
                </Box> */}

                {/* Output Language Dropdown */}
                <Box flex="1" minW="120px">
                  <DropdownWithMultiLingual
                    menuList={{ pos: 'relative', right: '75px' }}
                    placeholder="English"
                    onClick={handleChangeOutputLanguage}
                    options={languageOptions.map(value => ({ value }))}
                    title="Output Language"
                  />
                </Box>

                {/* AI Correction Button */}
                <Box
                  as="button"
                  type="button"
                  border="1px solid #E6E7E9"
                  borderRadius="full"
                  w="40px"
                  h="40px"
                  p="8px"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  cursor={textFieldValue ? "pointer" : "not-allowed"}
                  opacity={textFieldValue ? 1 : 0.5}
                  pointerEvents={textFieldValue ? "auto" : "none"}
                  onClick={() => textFieldValue && correctOrders("edit")}
                  flexShrink="0"
                  bg="white"
                  _hover={textFieldValue ? { bg: "#f0f0f0" } : {}}
                >
                  <Image w="28px" src="/assets/svgs/ai-star-outline.svg" />
                </Box>
              </Flex>
            </Box>
          </>
        }
        modalFooterBtn={
          <>
            <HStack width="100%" justifyContent="flex-end">
              {/* <PrimaryButton
          buttonText="Update notes"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={() => {
            editGeneralDoctorNotes();
            editGeneralDoctorNotesModal.current.closeModal();
          }}
        /> */}
              <PrimaryButton
                buttonText="Update notes"
                btnStyle={{
                  w: "auto",
                  h: "2.5rem",
                  px: "2rem",
                }}
                onClick={async () => {
                  await editGeneralDoctorNotes();
                  handleEditModalClose();
                  // editGeneralDoctorNotesModal.current.closeModal();
                  // setIsEditModalOpen(false)
                }}
              />
            </HStack>

            {/* <HStack
        p={2}
        bottom="0"
        width="100%"
        alignItems='center'
      >
        <Box w='25%'>
        <DropdownWithMultiLingual 
          menuList={{pos:'relative', right:'75px'}}
          placeholder="English"
          onClick={handleChangeLanguage}
          options={languageOptions.map(value => ({ value }))}
          title="Input Language"
        />
        </Box>
        
        <GPUChatAudioManagerSpeechMode
          transcriber={activeTranscriber}
          mode={mode}
          setPlaceholder={setPlaceholder}
          setTyping={setTyping}
          onRecordingStateChange={handleRecordingStateChange} 
        />

        {isRecording && (
          <AudioDisplayForClutter
            mx="auto"
            borderRadius="lg"
            stream={stream}
          />
        )}
        <Box w='25%'>
        <DropdownWithMultiLingual 
          menuList={{pos:'relative', right:'75px'}}
          placeholder="English"
          onClick={handleChangeOutputLanguage}
          options={languageOptions.map(value => ({ value }))}
          title="Output Language"
        />
        </Box>
        <Box
          as="button"
          type="button"
          border="1px solid #E6E7E9"
          borderRadius="full"
          w="36px"
          h="auto"
          p="10px"
          mr='10px'
          display="flex"
          justifyContent="center"
          alignItems="center"
          cursor={textFieldValue ? "pointer" : "not-allowed"}
          opacity={textFieldValue ? 1 : 0.5}
          pointerEvents={textFieldValue ? "auto" : "none"}
          onClick={() => textFieldValue && correctOrders("edit")}
        >
          <Image w="26px" src="/assets/svgs/ai-star-outline.svg" />
        </Box>
        <PrimaryButton
          buttonText="Update notes"
          btnStyle={{
            w: "100%",
            h: "2.5rem",
          }}
          onClick={() => {
            editGeneralDoctorNotes();
            editGeneralDoctorNotesModal.current.closeModal();
          }}
        />
      </HStack> */}
          </>
        }
      />

      {/* Discharge Patient starts */}
      <DynamicModal
        ref={dischargePatientModal}
        modalHeader={`Discharge Patient?`}
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to Discharge?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              // variant="deleteBtn"
              buttonText="Discharge"
              btnStyle={{
                w: "100%",
                h: "2.5rem",
              }}
              onClick={() => {
                handleDischargeNotes();
              }}
            />
          </>
        }
      />

    </>
  );
};

export default DoctorNotesIndex;
